// Keyed by short, stable kebab-case keys (e.g. "forgot-password-title") rather
// than the literal English string — makes entries easy to find/grep later and
// keeps translations intact if the English copy is later reworded.
export default {
   "forgot-password-title": "Esqueceu-se da sua palavra-passe?",
   "forgot-password-description":
      "Introduza o seu e-mail abaixo para receber um código de verificação e recuperar a sua palavra-passe",
   email: "E-mail",
   cancel: "Cancelar",
   submit: "Enviar",
   "menu-section-stakeholders": "Partes interessadas",
   "menu-section-setup": "Configuração",
   "menu-section-implementation": "Implementação",
   "menu-section-support": "Apoio",
   "menu-item-experts": "Especialistas",
   "menu-item-approvers": "Aprovadores",
   "menu-item-organizations": "Organizações",
   "menu-item-requests": "Pedidos",
   "menu-item-assessments": "Avaliações",
   "menu-item-modules": "Módulos",
   "menu-item-targets": "Metas",
   "menu-item-workspaces": "Espaços de trabalho",
   "menu-item-tickets": "Tickets",
   "menu-section-organization-management": "Gestão da organização",
   "menu-section-my-account": "A minha conta",
   "menu-item-profile": "Perfil",
   "menu-item-team": "Equipe",
   "menu-item-help-desk": "Central de ajuda",

   name: "Nome",
   country: "País",
   "phone-number": "Número de telefone",
   expertise: "Especialização",
   "disabled-reason": "Motivo da desativação",
   "not-applicable": "N/A",
   export: "Exportar",
   "status-pending": "Pendente",
   "status-rejected": "Rejeitado",
   "status-active": "Ativo",
   "status-disabled": "Desativado",

   "experts-management-title": "Especialistas",
   "experts-request-tab": "Pedido de especialista",
   "experts-approved-tab": "Especialistas aprovados",
   "experts-deleted-button": "Especialistas eliminados",
   "experts-status-deactivated": "Desativado",

   "filter-search-label": "Qual está a procurar?",
   "search-placeholder": "Procurar",
   "search-by-name-placeholder": "Procurar por nome",
   "search-task-by-name-placeholder": "Procurar uma tarefa pelo seu nome",
   "search-module-by-name-placeholder": "Procurar um módulo pelo seu nome",
   "search-workspace-by-name-placeholder": "Procurar um espaço de trabalho pelo seu nome",
   "search-assessment-by-name-placeholder": "Procurar uma avaliação pelo seu nome",
   "search-expert-by-name-placeholder": "Procurar um especialista pelo seu nome",
   "search-request-by-name-placeholder":
      "Procurar um pedido pelo nome da organização requerente",
   "search-request-by-email-placeholder":
      "Procurar um pedido pelo e-mail da organização requerente",
   "search-request-by-name-or-email-placeholder": "Pesquisar pelo nome ou email",
   "search-invoice-by-name-placeholder": "Procurar uma fatura pelo seu nome",
   "search-organization-by-name-placeholder": "Procurar uma organização pelo seu nome",
   "filter-by-type-placeholder": "Filtrar por tipo",
   "filter-by-start-date-placeholder": "Filtrar por data de início",
   "filter-by-end-date-placeholder": "Filtrar por data de fim",
   "filter-by-year-placeholder": "Filtrar por ano",
   "filter-tasks-by-assigned-member-placeholder": "Filtrar tarefas por membro atribuído",
   "filter-tasks-by-status-placeholder": "Filtrar tarefas por estado",
   "filter-workspace-request-by-status-placeholder": "Filtrar pedidos de espaço de trabalho por estado",
   "filter-workspace-by-country-placeholder": "Filtrar espaços de trabalho por país",
   "filter-experts-by-country-placeholder": "Filtrar especialistas por país",
   "filter-by-submission-date-placeholder": "Filtrar por data de submissão",
   "filter-by-assessments-placeholder": "Filtrar por avaliações",
   "filter-by-assessment-placeholder": "Filtrar por avaliação",
   "filter-by-workspace-placeholder": "Filtrar por espaço de trabalho",
   "filter-by-score-placeholder": "Filtrar por pontuação",
   "filter-by-country-placeholder": "Filtrar por país",
   "filter-by-operating-countries-placeholder": "Filtrar por países de atuação",
   "filter-by-sectors-placeholder": "Filtrar por setores",
   "export-organizations-button": "Exportar organizações",
   "filter-by-module-placeholder": "Filtrar por módulo",
   "filter-by-round-placeholder": "Filtrar por ronda",
   "filter-by-section-placeholder": "Filtrar por secção",
   "filter-by-owner-placeholder": "Filtrar por proprietário",
   "search-by-its-name-placeholder": "Procurar por nome",
   "guided-assessment": "Avaliação guiada",
   "self-assessment": "Autoavaliação",
   "clear-all-button": "Limpar tudo",
   "filters-button": "Filtros",
   workspace: "Espaço de trabalho",
   assessment: "Avaliação",
   score: "Pontuação",
   city: "Cidade",
   "operating-countries": "Países de atuação",
   sectors: "Setores",
   type: "Tipo",
   organizations: "Organizações",
   "select-workspace-placeholder": "Selecione o espaço de trabalho",
   "select-assessment-placeholder": "Selecione a avaliação",
   "select-score-range-placeholder": "Selecione o intervalo de pontuação",
   "select-country-placeholder": "Selecione o país",
   "select-base-city-placeholder": "Selecione a sua cidade de base",
   "select-sectors-placeholder": "Selecione os setores",
   "select-type-placeholder": "Selecione o tipo",

   "toast-oops-title": "Ups! Ocorreu um problema!",
   "toast-request-accepted-success-title": "Pedido aceite com sucesso!",
   "toast-request-accepted-success-description":
      "Este pedido foi aceite com sucesso; o utilizador requerente será notificado da resposta.",
   "toast-request-accept-error-description":
      "Ocorreu um problema ao aceitar este pedido, tente novamente.",
   "toast-request-rejected-success-title": "Pedido rejeitado com sucesso!",
   "toast-request-rejected-success-description":
      "Este pedido foi rejeitado com sucesso; o utilizador requerente será notificado da resposta.",
   "toast-request-reject-error-description":
      "Ocorreu um problema ao rejeitar este pedido, tente novamente.",
   "toast-requests-accepted-success-title": "Pedidos aceites com sucesso!",
   "toast-requests-accepted-success-description":
      "Os pedidos foram aceites com sucesso; os utilizadores requerentes serão notificados da resposta.",
   "toast-requests-accept-error-description":
      "Ocorreu um problema ao aceitar estes pedidos, tente novamente.",
   "toast-requests-rejected-success-title": "Pedidos rejeitados com sucesso!",
   "toast-requests-rejected-success-description":
      "Os pedidos foram rejeitados com sucesso; os utilizadores requerentes serão notificados da resposta.",
   "toast-requests-reject-error-description":
      "Ocorreu um problema ao rejeitar estes pedidos, tente novamente.",
   "approve-all-button": "Aprovar tudo",
   "reject-all-button": "Rejeitar tudo",

   "search-target-placeholder": "Procurar uma meta por avaliação ou nome do módulo",
   "show-active-rounds-checkbox": "Mostrar rondas ativas",

   "general-score-column": "Pontuação geral",
   "submissions-column": "Submissões",
   "tasks-column": "Tarefas",
   "areas-complete-text": "áreas concluídas",
   "organizations-progress-summary-title": "Resumo do progresso das organizações",
   "export-progress-summary-button": "Exportar resumo do progresso",
   "select-module-performance-label":
      "Selecione o módulo para ver o desempenho das organizações",
   "all-modules-placeholder": "Todos os módulos",

   "registration-request-tab": "Pedido de registo",
   "workspace-request-tab": "Pedido de espaço de trabalho",
   "assessment-request-tab": "Pedido de avaliação",
   "status-approved": "Aprovado",
   "requesting-user-column": "Utilizador requerente",
   "request-date-column": "Data do pedido",
   "approval-date-column": "Data de aprovação",
   "processed-by-column": "Processado por",
   "workspace-name-column": "Nome do espaço de trabalho",
   "assessment-name-column": "Nome da avaliação",
   "consultant-name-column": "Nome do consultor",
   "rejection-date-column": "Data de rejeição",
   "accept-request-title": "Aceitar pedido",
   "accept-request-button": "Aceitar pedido",
   "accept-request-description":
      "Está prestes a aceitar este pedido. Esta ação não pode ser anulada.",
   "reject-request": "Rejeitar pedido",
   "reject-request-description":
      "Está prestes a rejeitar este pedido. Esta ação não pode ser anulada.",
   "confirm-continue-text": "Tem a certeza de que pretende continuar?",
   "reject-button": "Rejeitar",
   "approve-button": "Aprovar",
   "organization-request-title": "Pedido de organização",
   "foundation-label": "Fundação",
   "address-label": "Morada",
   "organization-sectors-label": "Setores da organização",
   "organization-type-label": "Tipo de organização",
   "organization-size-label": "Dimensão da organização",
   "organization-name-label": "Nome da organização",
   "organization-description-label": "Descrição da organização",

   "organization-deleted-success-title": "Organização eliminada com sucesso!",
   "organization-deleted-success-description": "Esta organização foi eliminada com sucesso.",
   "organization-delete-error-description":
      "Ocorreu um problema ao eliminar esta organização, tente novamente.",
   "organization-restored-success-title": "Organização restaurada com sucesso!",
   "organization-restored-success-description": "Esta organização foi restaurada com sucesso.",
   "organization-restore-error-description":
      "Ocorreu um problema ao desativar esta organização, tente novamente.",
   "organization-restore-failed-error-description":
      "Tivemos um problema ao restaurar esta organização, tente novamente.",
   "organization-disabled-success-title": "Organização desativada com sucesso!",
   "organization-disabled-success-description": "Esta organização foi desativada com sucesso.",
   "disable-organization-title": "Desativar organização",
   "disable-organization-description-text":
      "Está prestes a desativar esta organização. Ela será movida para a lista de organizações desativadas até ser restaurada.",
   "reason-for-disabling-label": "Motivo da desativação",
   "disable-organization-reason-placeholder":
      "Indique o motivo para desativar esta organização",
   "disable-button": "Desativar",
   "restore-organization-title": "Restaurar organização",
   "registration-date-column": "Data de registo",
   "organization-list-title": "Lista de organizações",
   "enroll-organizations-button": "Inscrever noutro espaço de trabalho",
   "registered-organizations-label": "Organizações registadas",
   "average-score-label": "Pontuação média",
   "registered-as-of-text": "Registada em",
   "social-networks-title": "Redes sociais",
   "offices-title": "Escritórios",
   "ongoing-projects-label": "Projetos em curso",
   "members-label": "Membros",
   "representative-label": "Representante",
   "representative-name-label": "Nome do representante",
   "representative-title-label": "Cargo do representante",
   "representative-location-label": "Localização do representante",
   "representative-phone-label": "Telefone do representante",
   "representative-skype-label": "Skype do representante",
   "representative-email-label": "E-mail do representante",

   "workspace-required-validation": "O espaço de trabalho é obrigatório",
   "organizations-enrolled-success-title": "Organizações inscritas com sucesso!",
   "organizations-enrolled-success-description":
      "Estas organizações foram inscritas com sucesso no espaço de trabalho que selecionou.",
   "organizations-enroll-error-description":
      "Ocorreu um problema ao inscrever estas organizações, tente novamente.",
   "enroll-organization-modal-title": "Inscrever organização noutro espaço de trabalho",
   "select-workspace-to-enroll-label": "Selecione o espaço de trabalho onde inscrever as organizações",
   "confirm-button": "Confirmar",
   "delete-button": "Eliminar",
   "delete-organization-title": "Eliminar organização",
   "delete-organization-description":
      "Está prestes a eliminar esta organização. Esta ação não pode ser anulada.",

   "update-successful-message": "Atualização efetuada com sucesso",
   "max-50-symbols-validation": "Máximo 50 caracteres",
   "min-3-symbols-validation": "Mínimo 3 caracteres",
   "invalid-email-validation": "E-mail inválido",
   "required-validation": "Obrigatório",
   "edit-organization-details-title": "Editar dados da organização",
   "project-number-title": "Número de projetos",
   "ongoing-project-number-label": "Número de projetos em curso",
   "social-label": "Redes sociais",
   "website-label": "Site",
   "facebook-label": "Facebook",
   "twitter-label": "Twitter",
   "linkedin-label": "Linkedin",
   "instagram-label": "Instagram",
   "back-button": "Voltar",
   "update-button": "Atualizar",

   "representative-removed-success-title": "Dados do representante removidos com sucesso!",
   "representative-removed-success-description": "Os dados do seu representante foram removidos.",
   "representative-remove-error-description":
      "Ocorreu um problema ao remover os dados do seu representante, tente novamente.",
   "profile-status-changed-title": "O estado do seu perfil foi alterado!",
   "profile-status-changed-description": "O estado do seu perfil foi alterado com sucesso.",
   "profile-status-change-error-description":
      "Ocorreu um problema ao alterar o estado do perfil, tente novamente.",
   "go-back-to-organizations-link": "Voltar às organizações",
   "print-profile-button": "Imprimir perfil",
   "make-profile-public-button": "Tornar o perfil público",
   "make-profile-private-button": "Tornar o perfil privado",
   "complete-profile-reminder-title": "Não se esqueça de completar o seu perfil!",
   "complete-profile-reminder-description":
      "Maximize a sua visibilidade na comunidade através de um perfil completo e tornando-o público.",
   "complete-profile-now-button": "Completar perfil agora",
   "profile-status-label": "Estado do perfil",
   "private-status": "Privado",
   "public-status": "Público",
   "organization-email-label": "E-mail da organização",
   "base-country-label": "País de base",
   "zip-code-label": "Código postal",
   "about-label": "Sobre",
   "foundation-date-label": "Data de fundação",
   "organizations-size-label": "Dimensão da organização",
   "countries-where-operate-label": "Países onde as organizações operam",
   "sector-that-works-label": "Setor em que a organização trabalha",
   "representative-details-title": "Dados do representante",
   "delete-all-representative-info-button": "Eliminar todos os dados do representante",
   "add-representative-details-button": "Adicionar dados do representante",
   "no-information-available-text": "Não existem informações disponíveis",
   "location-label": "Localização",
   "edit-representative-details-button": "Editar dados do representante",
   "assessments-scores-title": "Pontuações das avaliações",
   "assessments-scores-description":
      "Consulte os resultados desta organização nas avaliações concluídas.",
   "select-self-assessment-placeholder": "Selecione a autoavaliação",
   "no-self-assessment-yet-title": "Ainda não existe autoavaliação",
   "no-self-assessment-yet-description": "Esta organização ainda não concluiu uma autoavaliação",
   "select-guided-assessment-placeholder": "Selecione a avaliação guiada",
   "no-guided-assessment-yet-title": "Ainda não existe avaliação guiada",
   "no-guided-assessment-yet-description":
      "Esta organização ainda não concluiu uma avaliação guiada",
   "team-member-list-title": "Lista de membros da equipa",
   "team-member-list-description":
      "Adicione os membros da sua equipa e colabore para fortalecer a sua organização. Esta secção é visível apenas para si. Mesmo que o seu perfil seja público, mais ninguém poderá ver os membros que adicionar.",
   "latest-round-label": "Última ronda",
   "size-label": "Dimensão",
   "select-number-placeholder": "Selecione o número",
   "select-date-placeholder": "Selecione uma data",

   "profile-updated-success-title": "Perfil atualizado com sucesso!",
   "profile-updated-success-description": "As informações do seu perfil foram atualizadas corretamente.",
   "profile-update-error-description":
      "Ocorreu um problema ao atualizar as informações do seu perfil, tente novamente.",
   "international-name-required-validation": "O nome internacional é obrigatório",
   "date-of-establishment-required-validation": "A data de constituição é obrigatória",
   "address-required-validation": "A morada é obrigatória",
   "zip-code-required-validation": "O código postal é obrigatório",
   "email-required-validation": "O e-mail é obrigatório",
   "invalid-phone-number-validation": "Número de telefone inválido",
   "phone-number-required-validation": "O número de telefone é obrigatório",
   "at-least-one-sector-required-validation": "É obrigatório pelo menos um setor",
   "organization-size-required-validation": "A dimensão da organização é obrigatória",
   "at-least-one-country-required-validation": "É obrigatório pelo menos um país",
   "base-country-required-validation": "O país de base é obrigatório",
   "city-required-validation": "A cidade é obrigatória",
   "edit-profile-title": "Editar perfil",
   "organization-details-tab": "Dados da organização",
   "international-name-placeholder": "Nome internacional",
   "description-placeholder": "Descrição",
   "foundation-year-label": "Ano de fundação",
   "select-organization-size-placeholder": "Selecione a dimensão da organização",
   "countries-where-operates-label": "Países onde a organização opera",
   "select-operating-countries-placeholder": "Selecione os países de atuação",
   "working-sector-label": "Setor de atividade",
   "select-sectors-alt-placeholder": "Selecione os setores",
   "contact-information-tab": "Informações de contacto",
   "organizations-email-label": "E-mail da organização",
   "select-base-country-placeholder": "Selecione o país de base",
   "select-a-city-placeholder": "Selecione uma cidade",
   "save-changes-button": "Guardar alterações",

   // Profile information page (account profile edit forms)
   "name-label": "Nome",
   "city-label": "Cidade",
   "birthdate-label": "Data de nascimento",
   "select-your-prefix": "Selecione o seu",
   "area-of-expertise-colon-label": "Área de especialização:",
   "years-suffix-label": "anos",
   "professional-details-title": "Detalhes profissionais",
   "enter-current-password-placeholder": "Insira sua senha atual",
   "enter-new-password-placeholder": "Insira sua nova senha",
   "enter-new-password-again-placeholder": "Insira sua nova senha novamente",
   "enter-your-email-placeholder": "Insira seu e-mail",

   // Login information page (LoginInfo.js)
   "account-information-label": "Informações da conta",
   "email-label": "E-mail",
   "current-password-label": "Senha atual",
   "new-password-label": "Nova senha",
   "password-hint-intro-text": "Para proteger sua conta, sua senha deve conter pelo menos:",
   "password-hint-length": "8 caracteres",
   "password-hint-uppercase": "Uma letra maiúscula",
   "password-hint-lowercase": "Uma letra minúscula",
   "password-hint-number": "Um número",
   "password-hint-special": "Um caractere especial",
   "change-password-here-text": "Você pode alterar sua senha aqui",
   "email-changed-success-title": "E-mail alterado com sucesso!",
   "email-changed-success-description": "Seu e-mail foi atualizado corretamente.",
   "email-update-error-description":
      "Tivemos um problema ao alterar seu e-mail, por favor tente novamente.",
   "password-changed-success-title": "Senha alterada com sucesso!",
   "password-changed-success-description": "Sua senha foi atualizada corretamente.",
   "password-update-error-description":
      "Tivemos um problema ao alterar sua senha, por favor tente novamente.",
   "current-password-required-validation": "Senha atual é obrigatória",
   "new-password-required-validation": "Nova senha é obrigatória",
   "confirm-new-password-required-validation": "Confirmação da nova senha é obrigatória",

   // Account management: deactivate/delete account (LoginInfo.js)
   "account-management-title": "Gestão da conta",
   "deactivate-account-title": "Desativar conta",
   "deactivate-account-description":
      "Você pode desativar sua conta aqui. Isso tornará sua conta temporariamente inutilizável. No entanto, esta ação é totalmente reversível, e",
   "deactivate-account-explanation":
      "você pode reativar sua conta a qualquer momento simplesmente fazendo login novamente.",
   "delete-account-title": "Excluir conta",
   "delete-account-description":
      "Excluir sua conta removerá permanentemente todos os seus dados do nosso sistema.",
   "delete-account-explanation":
      "Esta ação é irreversível, o que significa que, uma vez excluída sua conta, você não poderá recuperar nenhuma de suas informações ou conteúdo.",
   "delete-account-explanation-2": "Se você tem certeza de que deseja continuar,",
   "delete-account-explanation-3":
      "esteja ciente de que perderá o acesso a todos os serviços e dados associados à sua conta.",
   "delete-account-modal-title": "Excluir sua conta",
   "deactivate-account-modal-title": "Desativar sua conta",
   "delete-account-modal-description": "Lamentamos vê-lo partir, mas respeitamos sua decisão!",
   "deactivate-account-modal-description":
      "Pensando em fazer uma pausa? Desativar sua conta é sempre uma opção.",
   "confirm-account-deletion-title": "Confirmar exclusão da conta",
   "confirm-account-deactivation-title": "Confirmar desativação da conta",
   "confirm-delete-account-description":
      "Você está prestes a excluir permanentemente sua conta e dados.",
   "confirm-deactivate-account-description": "Você está prestes a desativar sua conta.",
   "confirm-action-other-desc": "Tem certeza de que deseja continuar?",
   "delete-reason-1": "Não preciso mais do serviço.",
   "delete-reason-2": "Encontrei outro serviço que atende melhor às minhas necessidades.",
   "delete-reason-3": "Tive uma experiência ruim.",
   "delete-reason-4": "Estou preocupado com a privacidade dos meus dados.",
   "deactivate-reason-1": "Preciso de uma pequena pausa.",
   "deactivate-reason-2": "Estou muito ocupado no momento para usar a plataforma.",
   "deactivate-reason-3": "Estou lidando com assuntos pessoais.",
   "deactivate-reason-4": "Quero focar em outras prioridades por enquanto.",
   "other-please-specify-label": "Outro (especifique)",
   "enter-your-answer-placeholder": "Digite sua resposta aqui",
   "delete-account-feedback-prompt":
      "Adoraríamos ouvir sua opinião. Pode nos dizer por que está pensando em excluir sua conta?",
   "deactivate-account-feedback-prompt":
      "Adoraríamos ouvir sua opinião. Pode nos dizer por que está pensando em desativar sua conta?",
   "delete-account-followup-question":
      "Obrigado por estar conosco. Há algo que poderíamos ter feito para melhorar sua experiência?",
   "deactivate-account-followup-question":
      "Estamos sempre buscando melhorar. Se tiver sugestões ou comentários, adoraríamos ouvi-los",
   "delete-account-error-description":
      "Tivemos um problema ao excluir sua conta, por favor tente novamente.",
   "deactivate-account-error-description":
      "Tivemos um problema ao desativar sua conta, por favor tente novamente.",

   // Payment information page (PaymentInfo.js, SuccessPaymentInfo.js, FailedPaymentInfo.js)
   "choose-perfect-plan-title": "Escolha o plano perfeito para você",
   "billed-annually-text": "Cobrado anualmente",
   "workspaces-suffix-label": "espaços de trabalho",
   "members-suffix-label": "membros",
   "data-storage-limit-suffix-label": "limite de armazenamento de dados",
   "see-all-plan-details-link": "Ver todos os detalhes do plano",
   "plan-selected-label": "Plano selecionado",
   "select-this-plan-button": "Selecionar este plano",
   "view-billing-portal-button": "Ver portal de faturamento",
   "checkout-button": "Finalizar compra",
   "active-subscription-error-description":
      "O usuário já possui uma assinatura ativa. Por favor, escolha um plano diferente.",
   "payment-billing-error-description":
      "Tivemos um problema ao cobrar este pagamento, por favor tente novamente.",
   "purchase-successful-title": "Compra realizada com sucesso!",
   "payment-processed-success-text": "Seu pagamento foi processado com sucesso.",
   "thank-you-for-purchase-text": "Obrigado pela sua compra!",
   "go-back-to-payment-info-text": "Voltar às informações de pagamento",
   "purchase-failed-title": "Falha na compra",
   "purchase-failed-description":
      "Infelizmente, sua tentativa de compra recente não foi bem-sucedida. Pode ter havido um problema com o processamento do pagamento ou com as informações fornecidas. Por favor, verifique os detalhes do seu pagamento e tente novamente.",
   "apologize-inconvenience-text": "Pedimos desculpas pelo inconveniente e agradecemos sua paciência.",

   // Profile edit form validation messages (validationSchema.js)
   "min-3-symbols-validation": "Mínimo de 3 caracteres",
   "max-50-symbols-validation": "Máximo de 50 caracteres",
   "invalid-organization-email-validation": "E-mail da organização inválido",
   "organization-address-required-validation": "O endereço da organização é obrigatório",
   "operating-countries-required-validation": "Os países de operação são obrigatórios",

   // Account deleted/deactivated confirmation page (AccountDeletedORDeactivated.js)
   "account-action-icon-alt": "ação da conta",
   "account-deactivated-notice-text": "Sua conta foi desativada com sucesso a seu pedido.",
   "account-deleted-notice-text": "Sua conta foi excluída com sucesso a seu pedido.",
   "positive-experience-farewell-text":
      "Confiamos que você teve uma experiência positiva conosco e queremos que saiba que você será sempre bem-vindo de volta sempre que decidir retornar.",
   "kaporg-best-regards-text": "Atenciosamente, equipe KAPorg.",

   // Edit profile picture modal (EditProfilePicture.js)
   "edit-profile-picture-title": "Editar foto de perfil",
   "change-profile-picture-button": "Alterar foto de perfil",
   "delete-profile-picture-button": "Excluir foto de perfil",
   "profile-picture-updated-success-title": "Foto de perfil atualizada com sucesso!",
   "profile-picture-updated-success-description": "Sua foto de perfil foi atualizada corretamente.",
   "profile-picture-update-error-description":
      "Tivemos um problema ao atualizar sua foto de perfil, por favor tente novamente.",
   "profile-picture-deleted-success-title": "Foto de perfil excluída com sucesso!",
   "profile-picture-deleted-success-description": "Sua foto de perfil foi excluída.",
   "profile-picture-delete-error-description":
      "Tivemos um problema ao excluir sua foto de perfil, por favor tente novamente.",

   "name-required-validation": "O nome é obrigatório",
   "gender-required-validation": "O género é obrigatório",
   "role-required-validation": "A função é obrigatória",
   "team-member-added-success-title": "Membro da equipa adicionado com sucesso!",
   "team-member-added-success-description": "Este membro foi adicionado com sucesso à base de dados da sua equipa.",
   "team-member-add-error-description":
      "Ocorreu um problema ao adicionar este membro à base de dados da sua equipa, tente novamente.",
   "add-new-member-title": "Adicionar novo membro",
   "gender-label": "Género",
   "select-gender-placeholder": "Selecione o género",
   "role-label": "Função",
   "select-role-placeholder": "Selecione a função",
   "make-my-profile-public-button": "Tornar o meu perfil público",
   "make-my-profile-private-button": "Tornar o meu perfil privado",
   "make-profile-public-title": "Tornar o perfil público",
   "make-profile-private-title": "Tornar o perfil privado",
   "profile-visibility-notice-public":
      "Ao tornar o seu perfil público, as organizações nacionais, os doadores e os especialistas poderão ver as suas informações e resultados. Por isso, recomendamos que se certifique de que todas as suas informações estão completas antes de o tornar público.",
   "profile-visibility-notice-private":
      "Ao tornar o seu perfil privado, as organizações nacionais, os doadores e os especialistas poderão ver as suas informações e resultados. Por isso, recomendamos que se certifique de que todas as suas informações estão completas antes de o tornar privado.",
   "delete-member-title": "Eliminar membro",
   "delete-member-description": "Está prestes a eliminar este membro. Esta ação não pode ser anulada.",
   "delete-all-representative-details-title": "Eliminar todos os dados do representante",
   "delete-representative-info-description-1":
      "Está prestes a eliminar todas as informações do seu representante.",
   "delete-representative-info-description-2": "Pode voltar a adicioná-las mais tarde, se assim o desejar.",
   "delete-representative-info-description-3":
      "Lembre-se: ter um perfil completo é fundamental para uma melhor visibilidade e para gerar oportunidades de contacto dentro da comunidade.",
   "organizations-management-title": "Gestão de organizações",

   "representative-updated-success-title": "Dados do representante atualizados com sucesso!",
   "representative-updated-success-description":
      "As informações do seu representante foram atualizadas corretamente.",
   "representative-update-error-description":
      "Ocorreu um problema ao atualizar as informações do seu representante, tente novamente.",
   "edit-representative-detail-title": "Editar dados do representante",
   "full-name-label": "Nome completo",
   "phone-label": "Telefone",
   "edit-representative-button": "Editar representante",
   "representative-added-success-title": "Dados do representante adicionados com sucesso!",
   "representative-added-success-description":
      "As informações do seu representante foram adicionadas corretamente.",
   "representative-add-error-description":
      "Ocorreu um problema ao adicionar as informações do seu representante, tente novamente.",
   "create-representative-detail-title": "Criar novos dados de representante",

   "team-member-removed-success-title": "Membro da equipa removido com sucesso!",
   "team-member-removed-success-description":
      "Este membro foi removido com sucesso da base de dados da sua equipa.",
   "team-member-remove-error-description":
      "Ocorreu um problema ao remover este membro da base de dados da sua equipa, tente novamente.",
   "fullname-column": "Nome completo",
   "member-search-label": "Que membro está a procurar?",
   "search-member-by-name-placeholder": "Procurar um membro pelo seu nome",
   "add-member-button": "Adicionar membro",
   "new-member-button": "Novo membro",
   "birthdate-label": "Data de nascimento",
   "email-field-label": "E-mail",
   "name": "Nome",
   "email": "E-mail",
   "cancel": "Cancelar",
   "no-assessments-listed-text": "Nenhuma avaliação listada",
   "remaining-months-days-text": "{months} meses, {days} dias",
   "more-actions-label": "Mais ações",
   "sort-ascending-alt": "Ordenar ascendente",
   "sort-descending-alt": "Ordenar descendente",
   "error-unauthorized-text": "Desculpe, não tem autorização para aceder a esta página.",
   "error-page-not-found-text": "Desculpe, a página que visitou não existe.",
   "error-oops-title": "Ups...",
   "back-home-button": "Voltar ao início",
   "error-something-wrong-text": "Parece que algo correu mal. Estamos a trabalhar nisso",

   "requests-management-title": "Gestão de pedidos",
   "archived-assessments-link": "Avaliações arquivadas",
   "deleted-assessments-link": "Avaliações eliminadas",
   "add-new-assessment-button": "Nova avaliação",
   "assessment-list-title": "Avaliações",
   "archive-button": "Arquivar",
   "archive-assessment-title": "Arquivar avaliação",
   "delete-assessment-title": "Eliminar avaliação",
   "archive-assessment-description": "Está prestes a arquivar esta avaliação.",
   "delete-assessment-description": "Está prestes a eliminar esta avaliação.",

   "start-date-after-previous-end-validation": "A data de início deve ser posterior à data de fim anterior",
   "end-date-after-start-validation": "A data de fim deve ser posterior à data de início",
   "assessment-name-empty-validation": "O nome da avaliação não pode estar vazio",
   "submission-round-label-empty-validation": "A etiqueta da ronda de submissão não pode estar vazia",
   "date-fields-required-validation": "Os campos de data são obrigatórios",
   "start-date-required-validation": "A data de início é obrigatória",
   "end-date-required-validation": "A data de fim é obrigatória",
   "assessment-created-success-title": "Avaliação criada com sucesso!",
   "assessment-created-success-description":
      "Foi criada uma nova avaliação e adicionada à sua base de dados.",
   "assessment-create-error-description":
      "Ocorreu um problema ao criar esta avaliação, tente novamente.",
   "assessment-details-title": "Dados da avaliação",
   "assessment-name-label": "Nome da avaliação",
   "enter-assessment-name-placeholder": "Introduza o nome da avaliação",
   "assessment-type-label": "Tipo de avaliação",
   "submission-round-label-field": "Etiqueta da ronda de submissão",
   "enter-submission-round-placeholder": "Introduza a ronda de submissão",
   "start-date-label": "Data de início",
   "end-date-label": "Data de fim",
   "add-new-submission-round-button": "Adicionar nova ronda de submissão",
   "dynamic-range-label": "Intervalo dinâmico",
   "select-score-range-description":
      "Selecione o intervalo para as variáveis de pontuação da sua avaliação (até 5)",
   "score-variables-label": "variáveis de pontuação",
   "from-label": "De",
   "to-label": "a",
   "score-label-field": "Etiqueta da pontuação",
   "score-description-field": "Descrição da pontuação",
   "enter-label-description-placeholder": "Introduza uma descrição da etiqueta",
   "add-assessment-button": "Adicionar avaliação",
   "assessment-assigned-success-title": "Avaliação atribuída com sucesso!",
   "assessment-assigned-success-description":
      "Esta avaliação foi atribuída com sucesso aos membros da sua equipa. Serão notificados desta ação.",
   "assessment-assign-error-description":
      "Ocorreu um problema ao atribuir esta avaliação aos membros da sua equipa, tente novamente.",
   "assign-assessment-to-team-title": "Atribuir avaliação à equipa",
   "project-management-label": "Gestão de projetos",

   "assessment-updated-success-title": "Avaliação atualizada com sucesso!",
   "assessment-updated-success-description": "Esta avaliação foi atualizada corretamente.",
   "assessment-update-error-description":
      "Ocorreu um problema ao atualizar esta avaliação, tente novamente.",
   "edit-assessment-title": "Editar avaliação",
   "edit-assessment-of-team-title": "Editar a avaliação desta equipa",
   "select-project-management-placeholder": "Selecione a gestão de projetos",
   "module-assigned-success-title": "Módulo atribuído com sucesso!",
   "module-assigned-success-description":
      "Este módulo foi atribuído com sucesso aos seus colaboradores. Serão notificados desta ação.",
   "module-unassigned-success-title": "Atribuição do módulo anulada com sucesso!",
   "module-unassigned-success-description":
      "A atribuição deste módulo ao colaborador foi anulada com sucesso.",
   "module-assign-error-description":
      "Ocorreu um problema ao atribuir este módulo aos seus colaboradores, tente novamente.",
   "assign-module-to-members-title": "Atribuir módulo a membros",
   "module-name-label": "Nome do módulo",
   "members-to-assign-label": "Membros a quem atribuir este módulo",
   "unassign-button": "Anular atribuição",
   "assign-module-button": "Atribuir módulo",
   "member-required-validation": "O membro é obrigatório",

   "comparison-created-success-title": "Nova versão de comparação criada!",
   "comparison-created-success-description":
      "A nova versão de comparação foi criada com sucesso e está pronta para revisão.",
   "comparison-create-error-description":
      "Ocorreu um problema ao criar esta versão de comparação, tente novamente.",
   "duplicate-for-comparison-title": "Duplicar para comparação",
   "duplicate-comparison-description-1":
      "Esta ação criará uma cópia da avaliação e associará ambas as versões para comparação de resultados.",
   "duplicate-comparison-description-2":
      "Depois de duplicadas, as avaliações e os módulos associados não poderão ser modificados.",
   "current-assessment-label": "Avaliação atual",
   "new-comparison-version-label": "Nova versão de comparação",
   "comparison-suffix-label": "Comparação",
   "duplicate-comparison-note":
      "Nota: se necessário, pode remover a associação mais tarde para as editar de forma independente, mas a comparação deixará de estar disponível.",
   "duplicate-button": "Duplicar",
   "assessments-unlinked-success-title": "Avaliações desassociadas!",
   "assessments-unlinked-success-description":
      "As avaliações foram desassociadas com sucesso e podem agora ser editadas de forma independente.",
   "assessments-unlink-error-description":
      "Ocorreu um problema ao desassociar as avaliações, tente novamente.",
   "unlink-assessments-title": "Desassociar estas avaliações?",
   "unlink-assessments-description":
      "Deixarão de estar ligadas para comparação e a vista de comparação deixará de estar disponível.",
   "original-assessment-label": "Avaliação original",
   "duplicated-assessment-label": "Avaliação duplicada",
   "unlink-assessments-note": "Nota: depois de desassociadas, cada avaliação pode ser editada de forma independente.",
   "unlink-button": "Desassociar",
   "expert-name-column": "Nome do especialista",
   "years-of-experience-column": "Anos de experiência",
   "expert-cv-column": "CV do especialista",
   "cv-link-text": "Link do CV",
   "no-cv-available-text": "Sem CV disponível",
   "areas-of-expertise-column": "Áreas de especialização",
   "select-expert-request-access-title": "Selecione um especialista e peça acesso",
   "first-choose-expert-subtitle": "Primeiro escolha um especialista",
   "choose-expert-guide-hint": "Escolha um especialista para orientar a sua avaliação",
   "request-access-button": "Pedir acesso",
   "go-back-experts-list-link": "Voltar à lista de especialistas",
   "no-description-available-text": "Não existe descrição disponível",
   "no-expertise-listed-text": "Sem especialização indicada",
   "nationality-label": "Nacionalidade",
   "no-nationality-listed-text": "Sem nacionalidade indicada",
   "country-of-residence-label": "País de residência",
   "no-country-of-residence-text": "Sem país de residência",
   "no-operating-countries-listed-text": "Sem países de atuação indicados",
   "linkedin-profile-label": "Perfil do LinkedIn",
   "no-linkedin-profile-text": "Não foi indicado nenhum perfil do LinkedIn",
   "no-phone-number-listed-text": "Sem número de telefone indicado",
   "highest-degree-label": "Grau académico mais elevado obtido",
   "no-highest-degree-listed-text": "Sem grau académico mais elevado indicado",
   "fields-of-study-label": "Áreas de estudo",
   "no-study-fields-listed-text": "Sem áreas de estudo indicadas",
   "educational-institution-label": "Instituição de ensino",
   "no-educational-institution-listed-text": "Sem instituição de ensino indicada",
   "languages-label": "Idiomas",
   "no-languages-listed-text": "Sem idiomas indicados",
   "cv-label": "CV",
   "no-cv-listed-text": "Sem CV indicado",
   "certification-training-label": "Certificação ou formação especializada",
   "no-certification-listed-text": "Sem certificação ou formação especializada indicada",

   "archived-assessments-list-title": "Lista de avaliações arquivadas",
   "deleted-assessments-title": "Avaliações eliminadas",
   "delete-permanently-button": "Eliminar definitivamente",
   "unarchive-assessments-button": "Desarquivar avaliações",
   "restore-assessments-button": "Restaurar avaliações",
   "deleted-assessments-description":
      "Aqui pode consultar e restaurar as avaliações eliminadas. Qualquer avaliação que não seja restaurada no prazo de 60 dias será eliminada definitivamente.",
   "delete-assessment-permanently-title": "Eliminar avaliação definitivamente",
   "delete-assessments-permanently-title": "Eliminar avaliações definitivamente",
   "delete-selected-assessment-permanently-description":
      "Está prestes a eliminar definitivamente a avaliação selecionada.",
   "delete-selected-assessments-permanently-description":
      "Está prestes a eliminar definitivamente as avaliações selecionadas.",
   "action-cannot-be-undone-confirm-text":
      "Esta ação não pode ser anulada. Tem a certeza de que pretende continuar?",

   "request-sent-success-title": "Pedido enviado com sucesso!",
   "request-sent-success-description":
      "O seu pedido foi enviado ao administrador. Assim que o pedido for respondido, receberá um e-mail com a resposta.",
   "request-send-error-description": "Ocorreu um problema ao enviar o seu pedido, tente novamente.",
   "request-rejected-title": "Que pena! Parece que o seu pedido foi rejeitado",
   "request-rejected-description-line1":
      "Por agora não pode aceder a esta avaliação porque o seu pedido foi rejeitado.",
   "request-rejected-description-line2": "Mas não se preocupe! Pode voltar a pedir acesso.",
   "request-pending-title": "Já pediu acesso a esta avaliação!",
   "request-pending-description-line1":
      "O seu pedido foi enviado ao administrador desta avaliação. Assim que o pedido for respondido, receberá um e-mail com a resposta.",
   "request-pending-description-line2": "Entraremos em contacto consigo o mais brevemente possível.",
   "request-access-title": "Pedir acesso a esta avaliação",
   "request-access-description-part1": "Desbloqueie esta avaliação guiada para",
   "request-access-description-part2": "podermos atribuir os nossos especialistas",
   "request-access-description-part3": "da sua área de atividade para",
   "request-access-description-part4": "o apoiarem diretamente ao longo do processo de avaliação",
   "request-access-description-part5":
      "e o ajudarem a explorar formas de construir melhores parcerias e garantir financiamento para programas futuros.",

   "guided-assessments-title": "Avaliações guiadas",
   "assessments-list-title": "Lista de avaliações",
   "organizations-name-column": "Nome da organização",
   "assessment-column": "Avaliação",
   "status-column": "Estado",
   "not-started-status": "Não iniciado",
   "in-progress-status": "Em curso",
   "completed-status": "Concluído",

   "success-title": "Sucesso",
   "module-submitted-success-description": "Módulo submetido com sucesso",
   "no-submission-rounds-text": "Sem rondas de submissão",
   "submission-rounds-title": "Rondas de submissão",
   "round-target-label": "Meta",
   "module-submitted-modal-title": "Submeteu este módulo com sucesso!",
   "next-round-active-description":
      "Volte a esta avaliação quando a próxima ronda de submissão estiver ativa.",
   "remaining-time-current-round-label": "Tempo restante da ronda atual",
   "start-label": "Início",
   "end-label": "Fim",
   "linked-modules-title": "Módulos associados",
   "no-linked-modules-text": "Sem módulos associados",
   "finished-status": "Terminado",
   "completed-text": "concluído",

   "assigned-to-label": "Atribuído a",
   "assign-member-button": "Atribuir membro",
   "submitted-at-label": "Submetido em",
   "edit-assignment-button": "Editar atribuição",
   "assign-to-team-button": "Atribuir à equipa",
   "assessment-assigned-to-label": "Avaliação atribuída a:",
   "expert-modules-description":
      "Estes são os módulos a que o especialista que selecionou irá responder. Assim que o especialista submeter os módulos, poderá consultar os resultados e as respostas na secção Resultados.",

   "no-self-assessments-yet-title":
      "Parece que este espaço de trabalho ainda não tem autoavaliações!",
   "no-guided-assessments-yet-title":
      "Parece que este espaço de trabalho ainda não tem avaliações guiadas!",
   "work-on-guided-assessments-instead-description":
      "Mas não se preocupe, pode trabalhar nas avaliações guiadas em alternativa.",
   "work-on-self-assessments-instead-description":
      "Mas não se preocupe, pode trabalhar nas autoavaliações em alternativa.",

   "name-column": "Nome",
   "type-column": "Tipo",
   "created-by-column": "Criado por",
   "created-date-column": "Data de criação",
   "edit-action": "Editar",
   "founded-label": "Fundada em",
   "areas-label": "áreas",
   "staff-label": "equipe",
   "contact-label": "Contato",
   "online-label": "Online",
   "unlink-assessment-action": "Desassociar avaliação",
   "edit-assessment-alt": "Editar avaliação",
   "archive-assessment-alt": "Arquivar avaliação",
   "delete-assessment-alt": "Eliminar avaliação",
   "unlink-assessment-alt": "Desassociar avaliação",

   "assessment-deleted-success-title": "Avaliação eliminada com sucesso!",
   "assessment-deleted-success-description":
      "Esta avaliação foi eliminada com sucesso da sua base de dados.",
   "assessment-delete-error-description":
      "Ocorreu um problema ao eliminar esta avaliação, tente novamente.",
   "assessments-deleted-success-title": "Avaliações eliminadas com sucesso!",
   "assessments-deleted-success-description":
      "Estas avaliações foram eliminadas com sucesso da sua base de dados.",
   "assessments-delete-error-description":
      "Ocorreu um problema ao eliminar estas avaliações, tente novamente.",
   "assessment-restored-success-title": "Avaliação restaurada com sucesso!",
   "assessment-restored-success-description": "Esta avaliação foi restaurada com sucesso.",
   "assessment-unarchive-error-description":
      "Ocorreu um problema ao desarquivar esta avaliação, tente novamente.",
   "assessments-unarchived-success-title": "Avaliações desarquivadas com sucesso!",
   "assessments-unarchived-success-description":
      "Estas avaliações foram desarquivadas com sucesso.",
   "assessments-unarchive-error-description":
      "Ocorreu um problema ao desarquivar estas avaliações, tente novamente.",
   "assessment-archived-success-title": "Avaliação arquivada com sucesso!",
   "assessment-archived-success-description": "Esta avaliação foi arquivada com sucesso.",
   "assessment-archive-error-description":
      "Ocorreu um problema ao adicionar esta avaliação ao arquivo, tente novamente.",
   "assessment-trashed-success-title": "A avaliação foi movida para a reciclagem com sucesso!",
   "assessment-trashed-success-description":
      "Esta avaliação foi movida para a reciclagem com sucesso.",
   "assessment-trash-error-description":
      "Ocorreu um problema ao mover esta avaliação para a reciclagem, tente novamente.",

   "assessment-modules-title": "Módulos da avaliação",
   "module-name-column": "Nome do módulo",
   "go-to-module-button": "Ir para o módulo",

   "consultant-organization-list-title": "Lista de organizações do consultor",
   "country-column": "País",
   "progress-column": "Progresso",
   "submitted-status": "Submetido",
   "go-to-assessment-button": "Ir para a avaliação",

   "module-submitted-toast": "O módulo foi submetido com sucesso.",
   "no-permission-submit-module-warning": "Não tem permissão para submeter um módulo!",
   "submit-button": "Submeter",
   "module-submitted-text": "Este módulo foi submetido.",

   "choose-consultant-guide-title": "Escolha um consultor para orientar a sua avaliação",
   "consultant-profile-title": "Perfil do consultor",
   "consultant-label": "Consultor",
   "experience-title": "Experiência",
   "education-title": "Formação académica",
   "school-label": "Estabelecimento de ensino",
   "skills-title": "Competências",
   "select-this-consultant-button": "Selecionar este consultor",
   "enrolled-guided-assessment-success-title":
      "Foi inscrito com sucesso na avaliação guiada!",
   "consultant-contact-soon-description-part1": "O consultor",
   "consultant-contact-soon-description-part2":
      "entrará em contacto consigo em breve para iniciar as suas avaliações.",
   "go-to-assessments-button": "Ir para as avaliações",

   "improve-score-help-title":
      "Se pretender melhorar a sua pontuação e fazer crescer ainda mais a sua organização, a equipa da KAPorg está aqui para ajudar!",
   "request-guided-assessment-description-part1":
      "Peça já uma avaliação guiada para podermos atribuir os nossos especialistas da sua área de atividade para o apoiarem diretamente ao longo do processo de avaliação e o ajudarem a explorar formas de construir melhores parcerias e garantir financiamento para programas futuros.",
   "request-guided-assessment-description-part2":
      "Faça já o seu pedido e entraremos em contacto consigo o mais brevemente possível.",
   "request-assessment-code-button": "Pedir um código de avaliação",
   "have-assessment-code-button": "Tenho um código de avaliação",
   "assessment-code-title": "Código de avaliação",
   "enter-assessment-code-description":
      "Para aceder à sua avaliação, introduza abaixo o seu código de avaliação",
   "enter-code-here-label": "Introduza aqui o seu código",
   "please-enter-code-error": "Introduza o código",
   "assessment-list-label": "Lista de avaliações",
   "select-an-assessment-placeholder": "-Selecione uma avaliação-",
   "select-assessment-error": "Deve selecionar uma avaliação",
   "submit-request-button": "Enviar pedido",
   "request-assessment-code-title": "Pedir código de avaliação",
   "request-assessment-code-description":
      "Peça a sua avaliação e entraremos em contacto consigo. Assim que o pedido for aceite, receberá um e-mail com o código.",
   "select-assessment-from-list-description": "Selecione uma avaliação da lista abaixo",
   "code-valid-select-consultant-toast": "O seu código era válido e pode agora selecionar o consultor",

   "my-modules-tab": "Os meus módulos",
   "template-library-tab": "Biblioteca de modelos",

   "module-deleted-success-title": "Módulo eliminado com sucesso!",
   "module-deleted-success-description": "Este módulo foi removido com sucesso da sua base de dados.",
   "module-delete-error-description": "Ocorreu um problema ao eliminar este módulo, tente novamente.",
   "module-cannot-be-deleted-error": "O módulo não pode ser eliminado",
   "preview-action": "Pré-visualizar",
   "download-action": "Transferir",
   "turn-into-template-action": "Transformar em modelo",
   "preview-template-alt": "Pré-visualizar modelo",
   "edit-module-alt": "Editar módulo",
   "download-module-alt": "Transferir módulo",
   "turn-into-template-alt": "Transformar em modelo",
   "delete-module-alt": "Eliminar módulo",
   "title-column": "Título",
   "deleted-modules-button": "Módulos eliminados",
   "add-module-button": "Novo módulo",
   "add-module-modal-button": "Adicionar módulo",
   "add-new-module-title": "Adicionar novo módulo",
   "add-new-assessment-title": "Adicionar nova avaliação",
   "survey-status-editing": "Em edição",
   "survey-status-archived": "Arquivado",
   "survey-status-deployed": "Implementado",
   "survey-status-locked": "Bloqueado",

   "how-start-title": "Como pretende começar?",
   "create-form-title": "Criar formulário",
   "create-form-description":
      "Comece com uma estrutura vazia, adicionando secções e perguntas à medida que avança.",
   "import-form-title": "Importar formulário",
   "import-form-description": "Carregue um ficheiro com secções e perguntas predefinidas.",
   "use-template-title": "Utilizar um modelo",
   "use-template-description":
      "Comece com um formulário já guardado no sistema e ajuste-o facilmente às suas necessidades.",
   "continue-button": "Continuar",

   "module-details-title": "Dados do módulo",
   "enter-module-name-placeholder": "Introduza o nome do módulo",
   "enter-module-description-placeholder": "Introduza a descrição do módulo",
   "default-language-label": "Idioma predefinido",
   "select-default-language-module-placeholder": "Selecione o idioma predefinido do módulo",
   "select-assessment-label": "Selecionar avaliação",
   "select-assessment-module-placeholder": "Selecione a avaliação do módulo",

   "delete-module-title": "Eliminar módulo",
   "delete-template-title": "Eliminar modelo",
   "delete-module-confirm-description": "Está prestes a eliminar este módulo. Esta ação não pode ser anulada.",
   "delete-template-confirm-description":
      "Está prestes a eliminar este modelo. Esta ação não pode ser anulada.",

   "module-restored-success-title": "Módulo restaurado com sucesso!",
   "module-restored-success-description": "Este módulo foi restaurado com sucesso.",
   "module-restore-error-description": "Ocorreu um problema ao restaurar este módulo, tente novamente.",
   "deleted-modules-list-title": "Lista de módulos eliminados",
   "restore-modules-button": "Restaurar módulos",
   "deleted-modules-description":
      "Aqui pode consultar e restaurar os módulos eliminados. Qualquer módulo que não seja restaurado no prazo de 60 dias será eliminado definitivamente.",

   "module-name-required-validation": "O nome do módulo é obrigatório",
   "upload-module-file-label": "Carregar ficheiro do módulo",
   "drag-drop-file-text": "Arraste e largue o ficheiro aqui, ou",
   "click-to-select-file-text": "clique para selecionar o ficheiro",
   "max-file-size-text": "Tamanho máximo do ficheiro: 20MB",

   "module-create-error-description": "Ocorreu um problema ao criar este módulo, tente novamente.",
   "make-module-template-label": "Tornar este módulo um modelo",

   "not-a-xlsx-file-error": "não é um ficheiro xlsx",
   "upload-valid-xlsx-error": "Carregue um ficheiro xlsx válido antes de submeter.",
   "error-title": "Erro",
   "survey-imported-success-description": "Questionário importado com sucesso",
   "survey-import-failed-error": "Falha ao importar o questionário.",
   "copy-file-name-tooltip": "Copiar nome do ficheiro",
   "copied-tooltip": "Copiado!",
   "module-must-have-right-format-text":
      "O seu módulo tem de ter o formato correto para ser importado corretamente.",
   "download-format-link": "Transferir formato",
   "enter-description-placeholder": "Introduza a descrição",

   "min-3-characters-validation": "Mínimo 3 caracteres",
   "language-required-validation": "O idioma é obrigatório",
   "assessment-required-validation": "A avaliação é obrigatória",
   "new-module-suffix": "Novo módulo",

   "edit-module-title": "Editar módulo",
   "module-description-label": "Descrição do módulo",

   "template-deleted-success-title": "Modelo eliminado com sucesso!",
   "template-deleted-success-description":
      "Este modelo foi removido com sucesso da sua base de dados.",
   "template-delete-error-description":
      "Ocorreu um problema ao eliminar este modelo, tente novamente.",
   "edit-template-alt": "Editar modelo",
   "download-template-alt": "Transferir modelo",
   "duplicate-template-alt": "Duplicar modelo",
   "delete-template-alt": "Eliminar modelo",
   "copy-action": "Copiar",
   "module-title-column": "Título do módulo",
   "created-on-column": "Criado em",
   "last-updated-column": "Última atualização",

   "copy-suffix-label": "Cópia",
   "template-duplicated-success-title": "Modelo duplicado com sucesso!",
   "template-duplicated-success-description":
      "O seu modelo foi duplicado com sucesso. Pode agora editar e personalizar a nova cópia.",
   "template-duplicate-error-description":
      "Ocorreu um problema ao duplicar este modelo, tente novamente.",
   "copy-template-title": "Copiar modelo",
   "copy-template-description":
      "Está prestes a criar um modelo reutilizável com base na estrutura deste módulo. Poderá utilizar este modelo para criar rapidamente novos módulos.",
   "template-name-label": "Nome do modelo",
   "template-name-required-validation": "O nome do modelo é obrigatório",
   "enter-template-name-placeholder": "Introduza o nome do modelo",
   "description-optional-label": "(opcional)",
   "template-description-hint-placeholder":
      "Uma breve nota para ajudar a sua equipa a perceber quando utilizar este modelo",

   "no-templates-found-title": "Não foram encontrados modelos",
   "no-templates-found-description":
      "Não existem modelos disponíveis de momento. Tente novamente mais tarde ou crie um novo!",
   "sections-label": "Secções:",
   "use-template-button": "Utilizar modelo",

   "template-created-success-title": "Modelo criado com sucesso!",
   "template-created-success-description":
      "O seu novo modelo foi criado a partir da estrutura deste módulo. Pode agora editá-lo ou utilizá-lo para criar rapidamente novos módulos.",
   "template-create-error-description":
      "Ocorreu um problema ao criar este modelo, tente novamente.",
   "convert-module-to-template-title": "Converter módulo em modelo",
   "module-label": "Módulo",
   "structure-logic-copied-note":
      "Nota: apenas a estrutura e a lógica serão copiadas; as respostas não serão incluídas.",
   "create-template-button": "Criar modelo",

   "fetch-drafts-error": "Falha ao obter os rascunhos",
   "module-saved-draft-success": "Módulo guardado como rascunho com sucesso",
   "save-draft-error": "Falha ao guardar o rascunho",
   "reject-module-error": "Falha ao rejeitar o módulo",
   "submit-module-error": "Falha ao submeter o módulo",
   "preview-other-modules-text": "Pré-visualizar outros módulos desta avaliação",
   "my-saved-drafts-button": "Os meus rascunhos guardados",
   "save-as-draft-button": "Guardar como rascunho",
   "processing-text": "A processar...",
   "submit-module-button": "Submeter módulo",
   "reject-module-button": "Rejeitar módulo",
   "approve-module-button": "Aprovar módulo",

   "change-status-button": "Alterar estado",
   "change-module-status-editing-title": "Alterar o estado do módulo para Em edição",
   "change-module-status-editing-confirm-description":
      "Está prestes a alterar o estado do módulo para Em edição.",

   "language-label": "Idioma",
   "select-language-placeholder": "Selecione o idioma",
   "print-module-button": "Imprimir módulo",

   "save-as-draft-title": "Guardar como rascunho",
   "save-draft-description":
      "Para guardar um rascunho deste módulo, atribua-lhe um nome para o poder rever mais tarde. Os rascunhos que guardar são armazenados na nossa base de dados.",
   "save-draft-button": "Guardar rascunho",

   "start-new-draft-button": "Iniciar um novo rascunho",
   "my-saved-draft-title": "O meu rascunho guardado",
   "unsubmitted-drafts-description": "Tem rascunhos por submeter para este módulo.",
   "continue-draft-or-new-question": "Pretende continuar com um rascunho ou iniciar um novo?",
   "my-draft-label": "O meu rascunho",
   "no-drafts-found-text": "Não foram encontrados rascunhos. Inicie um novo rascunho.",

   "submit-module-confirm-description-part1":
      "Está prestes a submeter este módulo. Ao prosseguir, as suas respostas serão enviadas ao gestor de projeto para revisão e aprovação.",
   "submit-module-confirm-description-part2":
      "Certifique-se de que todas as suas respostas estão corretas, uma vez que não poderá efetuar alterações depois de submetidas.",

   "approve-request-confirm-description":
      "Está prestes a aprovar este pedido. Esta ação não pode ser anulada.",
   "feedback-required-validation": "O feedback é obrigatório",
   "reject-module-description-part1":
      "Forneça um feedback detalhado sobre o motivo da rejeição deste módulo.",
   "reject-module-description-part2":
      "Servirá de orientação para o membro da equipa responsável efetuar as correções necessárias.",
   "why-rejecting-module-label": "Porque está a rejeitar este módulo?",
   "enter-rejection-reason-placeholder": "Introduza o motivo da rejeição",

   "module-status-label": "Estado do módulo:",
   "survey-status-published": "Publicado",
   "edit-module-details-tooltip": "Editar dados do módulo",
   "page-preparing-text": "A preparar a página...",

   "add-section-to-module-tooltip": "Adicionar secção ao módulo",
   "add-inner-section-tooltip": "Adicionar subsecção",

   "question-type-section": "Secção",
   "question-type-select-one": "Escolha única",
   "question-type-text": "Texto",
   "question-type-file-upload": "Carregamento de ficheiro",
   "question-type-date": "Data",
   "question-type-phone-number": "Número de telefone",
   "question-type-rating": "Classificação",
   "question-type-ranking": "Ordenação",
   "question-type-select-multiple": "Escolha múltipla",
   "question-type-note": "Nota",
   "question-type-date-time": "Data & hora",
   "question-type-time": "Hora",
   "question-type-number": "Número",
   "question-type-acknowledge": "Confirmação",
   "question-type-matrix": "Matriz",
   "type-section-label-placeholder": "Escreva a etiqueta da sua secção",
   "type-question-label-placeholder": "Escreva a etiqueta da sua pergunta",

   "option-placeholder": "Opção",
   "enter-note-text-above": "Introduza acima o texto da sua nota.",
   "calculate-question-coming-soon": "Pergunta de cálculo - brevemente...",
   "file-upload-caps-label": "CARREGAMENTO DE FICHEIRO",
   "items-to-be-ranked-label": "Itens a ordenar",
   "text-question-type-label": "Tipo de pergunta de texto",
   "question-displayed-as-table-text": "Esta pergunta será apresentada como uma tabela",
   "row-questions-title": "Perguntas das linhas",
   "columns-questions-title": "Perguntas das colunas",
   "allow-numbers-range-only-text": "Permitir apenas números de um intervalo",
   "gps-question-coming-soon": "Pergunta de GPS - brevemente...",
   "type-label-optional-placeholder": "Escreva uma etiqueta (opcional)",
   "optional-placeholder": "Opcional",
   "reverse-answers-order-button": "Inverter a ordem das respostas",
   "type-answer-choice-placeholder": "Escreva uma opção de resposta",
   "label-text": "Etiqueta",
   "select-an-option-placeholder": "Selecione uma opção",
   "select-a-scale-placeholder": "Selecione uma escala",
   "enter-bulk-action-placeholder": "Introduza a ação em massa",
   "to-divider-label": "Até",
   "collect-date-info-text": "Recolher informação de data",
   "collect-time-info-text": "Recolher informação de hora",
   "collect-phone-number-info-text": "Recolher informação do número de telefone",
   "type-a-question-placeholder": "Escreva uma pergunta",
   "min-label": "mín:",
   "max-label": "máx:",
   "max-options-chosen-text": "Número máximo de opções que podem ser escolhidas",
   "all-options-label": "Todas",
   "answer-genius-label": "Assistente de respostas",
   "add-choices-button": "Adicionar opções",
   "bulk-actions-label": "Ações em massa",
   "enter-each-answer-choice-line-text": "Introduza cada opção de resposta numa linha separada.",

   "required-answer-label": "Resposta obrigatória",
   "delete-question-confirm-title": "Tem a certeza de que pretende eliminar esta pergunta?",
   "delete-section-confirm-title": "Tem a certeza de que pretende eliminar esta secção?",
   "this-action-cannot-be-undone-text": "Esta ação não pode ser anulada",
   "yes-confirm-button": "Sim",
   "no-confirm-button": "Não",
   "add-new-question-button": "Adicionar nova pergunta",
   "add-new-inner-section-button": "Adicionar nova subsecção",
   "add-new-section-button": "Adicionar nova secção",

   "show-logic-button": "Mostrar lógica",
   "display-condition-prefix-text": "Mostrar",
   "question-word-label": "Pergunta",
   "when-following-conditions-apply-text": "quando se aplicarem as seguintes condições:",
   "add-another-condition-button": "Adicionar outra condição",
   "should-match-all-the-criteria-placeholder-text": "deve corresponder a todos os critérios",
   "should-match-all-of-these-criteria-text": "deve corresponder a todos estes critérios",
   "should-match-any-of-these-criteria-text": "deve corresponder a qualquer um destes critérios",
   "operator-was-not-answered-label": "Não foi respondida",
   "operator-was-answered-label": "Foi respondida",
   "operator-equals-label": "Igual a (=)",
   "operator-not-equals-label": "Diferente de (!=)",
   "operator-greater-than-label": "Maior que (>)",
   "operator-less-than-label": "Menor que (<)",
   "operator-greater-than-or-equal-label": "Maior ou igual a (>=)",
   "operator-less-than-or-equal-label": "Menor ou igual a (<=)",

   "field-required-text": "Este campo é obrigatório",
   "type-your-answer-here-placeholder": "Escreva aqui a sua resposta",
   "you-must-select-text": "Tem de selecionar",
   "you-must-enter-date-and-time-text": "Tem de introduzir uma data e uma hora",
   "you-must-enter-a-number-text": "Tem de introduzir um número",
   "drag-drop-files-text": "Arraste e largue os ficheiros aqui, ou clique para selecionar ficheiros",
   "uploaded-file-label": "Ficheiro carregado:",
   "you-must-upload-file-text": "Tem de carregar um ficheiro",
   "all-rankings-must-be-selected-text": "Todas as ordenações têm de ser selecionadas",
   "please-specify-placeholder": "Especifique",
   "you-can-select-up-to-text": "Pode selecionar até",
   "choices-suffix-text": "opções.",
   "you-must-select-at-least-one-text": "Tem de selecionar pelo menos um",
   "you-must-select-one-text": "Tem de selecionar um",
   "you-must-select-a-time-text": "Tem de selecionar uma hora",

   "no-submission-made-yet-text": "Ainda não foi efetuada qualquer submissão para este módulo.",
   "approval-successful-title": "Concluído com sucesso",
   "submission-approved-successfully-text": "Submissão aprovada com sucesso",
   "fetch-submission-answers-error": "Falha ao obter as respostas da submissão",
   "approve-without-review-button": "Aprovar sem revisão",
   "send-for-approval-button": "Enviar para aprovação",
   "approve-module-pending-approver-description":
      "Está prestes a aprovar este módulo. Ao prosseguir, será enviado ao aprovador para uma revisão final antes de o seu estado ser marcado como",
   "approve-module-final-description-part1":
      "Está prestes a dar a aprovação final a este módulo. Ao prosseguir, o seu estado será marcado como",
   "approve-module-final-description-part2":
      "e os seus resultados ficarão disponíveis para análise. Esta ação não pode ser anulada. Tem a certeza de que pretende continuar?",
   "send-to-approver-for-review-label": "Enviar ao aprovador para revisão final",
   "approver-review-recommended-hint": "Recomendado - ignorar este passo finaliza o módulo de imediato.",
   "skipping-approver-review-warning-text":
      "Está a ignorar a revisão do aprovador. Este módulo será concluído sem uma segunda verificação.",
   "enter-detailed-feedback-placeholder": "Introduza aqui o seu feedback detalhado",

   "department-team-label": "Departamento/Equipa",
   "enter-approver-name-placeholder": "Introduza o nome do aprovador",
   "enter-approver-email-placeholder": "Introduza o e-mail do aprovador",
   "enter-approver-department-placeholder": "Introduza o departamento do aprovador",
   "approver-added-success-title": "Aprovador adicionado com sucesso!",
   "approver-added-success-description": "Este aprovador pode agora ser atribuído a avaliações.",
   "approver-updated-success-title": "Aprovador atualizado com sucesso!",
   "approver-updated-success-description": "Os dados deste aprovador foram atualizados.",
   "approver-add-error-description": "Ocorreu um problema ao adicionar este aprovador, tente novamente.",
   "approver-update-error-description": "Ocorreu um problema ao atualizar este aprovador, tente novamente.",
   "approver-delete-error-description": "Ocorreu um problema ao eliminar este aprovador, tente novamente.",
   "approver-deleted-success-title": "Aprovador eliminado com sucesso!",
   "approver-deleted-success-description": "Este aprovador foi removido.",
   "delete-approver-title": "Eliminar aprovador",
   "delete-approver-confirm-text": "Está prestes a eliminar este aprovador.",
   "add-approver-title": "Adicionar aprovador",
   "edit-approver-title": "Editar aprovador",
   "add-approver-button": "Adicionar aprovador",
   "approvers-title": "Aprovadores",
   "search-approver-by-name-placeholder": "Procurar um aprovador pelo seu nome",
   "filter-approvers-by-department-placeholder": "Filtrar aprovadores por departamento",

   "no-data-text": "Sem dados",
   "submitted-by-column": "Submetido por",
   "pending-modules-title": "Módulos pendentes",
   "approved-modules-title": "Módulos aprovados",
   "rejected-modules-title": "Módulos rejeitados",
   "filter-tasks-by-submission-date-placeholder": "Filtrar tarefas por data de submissão",
   "module-approvals-title": "Aprovações de módulos",
   "pending-modules-review-description":
      "Esta é a lista de módulos pendentes da sua revisão. Para prosseguir, clique em cada módulo, onde poderá aceitá-lo ou rejeitá-lo.",
   "the-approver-label": "o aprovador",
   "approver-label": "Aprovador",
   "select-an-approver-placeholder": "Selecione um aprovador",
   "go-to-revise-module-button": "Ir rever o módulo",
   "rejected-module-information-title": "Informações do módulo rejeitado",
   "feedback-from-label-prefix": "Feedback de",
   "the-project-manager-label": "o gestor de projeto",
   "awaiting-approver-status": "A aguardar aprovador",

   "module-title-label": "Título do módulo",
   "enter-module-title-placeholder": "Introduza o título do módulo",
   "module-description-label": "Descrição do módulo",
   "assigned-assessment-label": "Avaliação atribuída",
   "survey-updated-success-title": "Questionário atualizado com sucesso!",
   "module-updated-success-description": "Este módulo foi atualizado corretamente.",
   "edit-module-error-description": "Ocorreu um problema ao editar este módulo, tente novamente.",
   "form-builder-tab-label": "Construtor de formulário",
   "logic-builder-tab-label": "Construtor de lógica",
   "translate-questions-tab-label": "Traduzir perguntas",
   "score-questions-tab-label": "Pontuar perguntas",
   "stay-here-button": "Ficar aqui",
   "change-tab-button": "Mudar de separador",
   "unsaved-progress-title": "Progresso não guardado",
   "unsaved-changes-tab-text": "Tem alterações não guardadas neste separador.",
   "confirm-proceed-without-saving-part1": "Tem a certeza de que pretende continuar",
   "confirm-proceed-without-saving-part2": "sem guardar o progresso?",
   "module-status-changed-success-title": "Estado do módulo alterado com sucesso!",
   "module-status-changed-success-description": "O estado deste módulo foi alterado corretamente.",
   "problem-occurred-title": "Ocorreu um problema!",
   "change-status-error-description":
      "Ocorreu um problema ao alterar o estado deste módulo, tente novamente.",
   "publish-module-button": "Publicar módulo",
   "change-status-to-editing-button": "Alterar estado para Em edição",
   "changes-saved-success-description": "Alterações guardadas com sucesso",
   "save-progress-button": "Guardar progresso",
   "skip-logic-saved-success-description": "Lógicas de salto adicionadas com sucesso",
   "score-points-saved-success-description": "Pontos de pontuação adicionados com sucesso",
   "total-module-score-label": "Pontuação total do módulo:",
   "points-suffix": "pts",
   "answers-column-label": "Respostas",
   "score-column-label": "Pontuação",
   "input-score-placeholder": "Introduzir pontuação",
   "max-score-label": "Pontuação máxima:",
   "date-answer-label": "Resposta de data",
   "time-answer-label": "Resposta de hora",
   "answer-keywords-label": "Palavras-chave da resposta",
   "section-score-label": "Pontuação da secção:",
   "number-range-hint-prefix": "O intervalo para esta pergunta é",
   "number-range-hint-value": "1 a 50",
   "number-range-hint-suffix": ". Selecione as opções de resposta corretas para a pontuação:",
   "select-right-answer-choices-placeholder": "Selecione as opções de resposta corretas",
   "single-number-option-label": "Número único",
   "range-option-label": "Intervalo",
   "enter-range-correct-answers-label": "Introduza o intervalo de respostas corretas",
   "to-connector-label": "a",
   "enter-correct-number-label": "Introduza o número correto",
   "input-number-placeholder": "Introduzir número",
   "ranking-score-instructions-text":
      "Organize as opções pela ordem correta e, depois, atribua uma pontuação a cada uma",
   "input-phone-number-placeholder": "Introduzir número de telefone",

   "main-module-title": "Módulo principal",
   "main-module-description-text": "Estas são as perguntas do seu módulo principal",
   "default-language-placeholder": "Idioma predefinido",
   "translate-module-title": "Traduzir módulo",
   "write-translation-here-text": "Escreva aqui a tradução de cada pergunta",
   "translate-to-label": "Traduzir para",
   "select-a-language-placeholder": "--Selecione um idioma--",
   "select-language-first-error": "Selecione primeiro um idioma",
   "translation-saved-success-description": "Tradução guardada com sucesso",
   "save-translation-button": "Guardar tradução",

   "module-required-validation": "O módulo é obrigatório",
   "at-least-one-section-required-validation": "É obrigatória pelo menos uma secção",
   "resource-type-required-validation": "O tipo de recurso é obrigatório",
   "at-least-one-attachment-required-validation": "É obrigatório pelo menos um anexo",
   "description-required-validation": "A descrição é obrigatória",
   "tagged-topics-required-validation": "Os tópicos etiquetados são obrigatórios",
   "invalid-url-format-validation": "Formato de URL inválido",
   "link-url-required-validation": "O URL do link é obrigatório",
   "agree-to-terms-required-validation": "Tem de aceitar os termos",
   "section-required-validation": "A secção é obrigatória",
   "resources-added-success-title": "Recursos adicionados com sucesso!",
   "resources-added-success-description": "Estes recursos foram criados e adicionados à sua base de dados.",
   "upload-resource-matching-type-error": "Carregue um recurso que corresponda ao tipo selecionado.",
   "resources-updated-success-title": "Recursos atualizados com sucesso!",
   "resources-updated-success-description": "Estes recursos foram atualizados com sucesso.",
   "add-new-resource-title": "Novo recurso",
   "edit-resource-title": "Editar recurso",
   "resource-upload-shared-repository-notice":
      "Qualquer recurso que carregue na plataforma será publicado no repositório partilhado da KAPorg, ficando disponível para outros utilizadores o transferirem e partilharem, promovendo o apoio da comunidade.",
   "select-module-link-resource-label": "Selecione o módulo ao qual pretende associar este recurso",
   "all-modules-in-assessment-placeholder": "Todos os módulos desta avaliação",
   "select-section-link-resource-label":
      "Selecione a secção do módulo à qual pretende associar este recurso",
   "all-sections-of-module-placeholder": "Todas as secções do módulo",
   "resource-information-title": "Informações do recurso",
   "select-resource-type-label": "Selecione o tipo de recurso",
   "before-upload-select-type-hint": "Antes de carregar um recurso tem de selecionar o seu tipo",
   "paste-link-here-label": "Cole aqui o link",
   "enter-link-url-placeholder": "Introduza o URL do link",
   "upload-file-here-label": "Carregue aqui o ficheiro",
   "drag-drop-file-here-prefix": "Arraste e largue o ficheiro aqui, ou",
   "click-to-select-file-text": "clique para o selecionar",
   "max-file-size-text": "Tamanho máximo do ficheiro: 20MB",
   "enter-resource-description-label": "Introduza a descrição do recurso",
   "tagged-topics-label": "Tópicos etiquetados",
   "enter-tagged-topics-placeholder":
      "Introduza os tópicos com os quais este recurso pode estar relacionado",
   "upload-rights-confirmation-text":
      "Ao carregar este material, confirmo que possuo os direitos e as permissões necessários para o fazer.",
   "add-resource-button": "Adicionar recurso",
   "expert-name-column": "Nome do especialista",
   "operating-countries-column": "Países de atuação",
   "years-of-experience-column": "Anos de experiência",
   "expert-cv-column": "CV do especialista",
   "areas-of-expertise-column": "Áreas de especialização",
   "assign-experts-to-assessment-title": "Atribuir especialistas a esta avaliação",
   "select-expert-assign-assessment-text":
      "Selecione o especialista que pretende atribuir a esta avaliação.",
   "search-resource-by-name-placeholder": "Procurar um recurso pelo seu nome",
   "assign-expert-to-assessment-button": "Atribuir especialista a esta avaliação",
   "expert-assigned-success-title": "Especialista atribuído com sucesso!",
   "expert-assigned-success-description":
      "Este especialista foi atribuído e adicionado à base de dados do seu plano de ação.",
   "assign-expert-error-description":
      "Ocorreu um problema ao atribuir este especialista ao seu plano de ação, tente novamente.",
   "expert-removed-success-title": "Especialista removido com sucesso!",
   "expert-removed-success-description":
      "Este especialista foi removido da base de dados do seu plano de ação.",
   "remove-expert-from-assessment-button": "Remover especialista desta avaliação",
   "email-label-colon": "E-mail:",
   "description-label-colon": "Descrição:",
   "no-description-available-text": "Não existe descrição disponível",
   "no-expertise-listed-text": "Sem especialização indicada",
   "field-of-study-label": "Área de estudo",
   "no-field-of-study-listed-text": "Sem área de estudo indicada",
   "no-operating-countries-listed-text": "Sem países de atuação indicados",
   "languages-label": "Idiomas",
   "no-languages-listed-text": "Sem idiomas indicados",
   "linkedin-profile-label": "Perfil do LinkedIn",
   "no-linkedin-profile-text": "Não foi indicado nenhum perfil do LinkedIn",
   "delete-collection-title": "Eliminar coleção",
   "delete-collection-confirm-text":
      "Está prestes a eliminar esta coleção. Esta ação não pode ser anulada.",
   "delete-resource-title": "Eliminar recurso",
   "delete-resource-confirm-text":
      "Está prestes a eliminar este recurso. Esta ação não pode ser anulada.",
   "collection-deleted-success-title": "Coleção eliminada com sucesso!",
   "collection-deleted-success-description":
      "Esta coleção foi removida com sucesso da sua base de dados.",
   "resource-deleted-success-title": "Recurso eliminado com sucesso!",
   "resource-deleted-success-description":
      "Este recurso foi removido com sucesso da sua base de dados.",
   "delete-resource-error-description": "Ocorreu um problema ao eliminar este recurso, tente novamente.",
   "resource-preview-title": "Pré-visualização do recurso",
   "document-type-label": "Documento",
   "video-type-label": "Vídeo",
   "slide-type-label": "Apresentação",
   "tags-and-categories-label": "Etiquetas e categorias",
   "upload-date-label": "Data de carregamento",
   "description-label": "Descrição",

   "status-label-colon": "Estado:",
   "assign-to-label-colon": "Atribuir a:",
   "deadline-label-colon": "Prazo:",
   "resources-attached-section-text": "Recursos anexados a esta secção",
   "resource-link-label-colon": "Este é o link do recurso:",
   "task-title-required-validation": "O título da tarefa é obrigatório",
   "deadline-required-validation": "O prazo é obrigatório",
   "create-new-task-title": "Criar uma nova tarefa",
   "edit-task-title": "Editar tarefa",
   "task-title-label": "Título da tarefa",
   "task-title-example-placeholder": "Com que frequência dá formação aos seus colaboradores?",
   "enter-task-instruction-placeholder":
      "Introduza uma nota ou instrução que ajude a pessoa designada a realizar a tarefa",
   "assign-task-to-label": "Atribuir tarefa a",
   "select-member-assign-task-placeholder": "Selecione o membro a quem atribuir esta tarefa",
   "cant-find-member-assign-task-text": "Não encontra o membro a quem atribuir a tarefa?",
   "add-in-organization-management-text": "Adicione-o na gestão da organização",
   "upload-files-complete-task-label": "Carregue os ficheiros necessários para concluir esta tarefa",
   "can-add-up-to-3-resources-text": "Pode adicionar até 3 recursos",
   "deadline-label": "Prazo",
   "resource-link-optional-label": "O seu recurso é um link? Introduza-o aqui",
   "enter-resource-link-placeholder": "Introduza o link do seu recurso",
   "assign-task-title": "Atribuir tarefa",
   "assign-task-at-least-one-member-validation": "Atribua a tarefa a pelo menos um membro",
   "deadline-valid-date-validation": "O prazo tem de ser uma data válida",
   "select-deadline-placeholder": "Selecione o prazo",
   "task-added-assigned-success-title": "Tarefa adicionada e atribuída com sucesso!",
   "task-added-assigned-success-description":
      "Esta tarefa foi atribuída com sucesso; o membro que selecionou será notificado.",
   "assign-task-error-description": "Ocorreu um problema ao atribuir esta tarefa, tente novamente.",
   "select-status-title": "Selecionar estado",
   "task-updated-success-title": "Tarefa atualizada com sucesso!",
   "task-updated-success-description": "Esta tarefa foi atualizada com sucesso na sua base de dados.",
   "update-task-error-description": "Ocorreu um problema ao atualizar esta tarefa, tente novamente.",
   "task-deleted-success-title": "Tarefa eliminada com sucesso!",
   "task-deleted-success-description": "Esta tarefa foi removida com sucesso da sua base de dados.",
   "delete-task-error-description": "Ocorreu um problema ao eliminar esta tarefa, tente novamente.",
   "delete-task-title": "Eliminar tarefa",
   "delete-task-confirm-text": "Está prestes a eliminar esta tarefa. Esta ação não pode ser anulada.",
   "rounds-filter-label": "Rondas",
   "managers-filter-label": "Gestores",
   "generate-report-button": "Gerar relatório",
   "generate-report-title": "Gerar relatório",
   "choose-sections-report-text": "Escolha as secções a incluir no relatório.",
   "include-module-breakdown-label": "Incluir detalhe por módulo",
   "of-label": "de",
   "sections-selected-suffix": "secções selecionadas",
   "generate-button": "Gerar",
   "report-preview-title": "Pré-visualização do relatório",
   "edit-sections-button": "Editar secções",
   "assessment-report-eyebrow-text": "Relatório de avaliação",
   "no-sections-data-selected-text": "Não foram selecionadas secções com dados.",
   "assessment-report-pdf-heading": "RELATÓRIO DE AVALIAÇÃO",
   "exported-on-label": "Exportado em",
   "page-word": "Página",
   "add-review-note-title": "Adicionar nota de revisão",
   "edit-review-note-title": "Editar nota de revisão",
   "note-title-required-validation": "Introduza um título para a nota",
   "enter-note-title-placeholder": "Introduza o título da nota",
   "round-covered-label": "Ronda abrangida",
   "select-option-required-validation": "Selecione uma opção",
   "note-required-validation": "Introduza as suas notas",
   "summarize-progress-placeholder": "Resuma os principais progressos, decisões ou questões.",
   "add-note-button": "Adicionar nota",
   "staff-members-fetch-error": "Ocorreu um problema ao obter os colaboradores, atualize a página.",
   "task-priority-fetch-error": "Ocorreu um problema ao obter a prioridade da tarefa, atualize a página.",
   "select-section-add-task-error": "Selecione uma secção para adicionar esta tarefa.",
   "add-task-error-description": "Ocorreu um problema ao adicionar esta tarefa, tente novamente.",
   "add-new-task-title": "Adicionar nova tarefa",
   "task-name-label": "Nome da tarefa",
   "task-name-required-validation": "Introduza um nome para a tarefa",
   "enter-task-name-placeholder": "Introduza o nome da tarefa",
   "linked-questions-label": "Perguntas associadas",
   "select-questions-required-validation": "Selecione as perguntas",
   "linked-questions-helper-text": "Selecione as perguntas que esta tarefa pretende melhorar",
   "select-questions-placeholder": "Selecione as perguntas",
   "task-description-required-validation": "Introduza uma descrição",
   "enter-task-description-placeholder": "Introduza a descrição da tarefa",
   "select-member-required-validation": "Selecione um membro",
   "select-deadline-required-validation": "Selecione um prazo",
   "priority-label": "Prioridade",
   "select-priority-required-validation": "Selecione a prioridade",
   "select-priority-placeholder": "Selecione a prioridade",
   "resources-label": "Recursos",
   "select-resources-placeholder": "Selecione os recursos associados a esta tarefa",
   "select-resources-required-validation": "Selecione os recursos",
   "search-resource-placeholder": "Procurar um recurso",
   "browse-resources-library-text": "Explorar a biblioteca de recursos",
   "add-task-button": "Adicionar tarefa",
   "confirm-selection-button": "Confirmar seleção",
   "resource-library-title": "Biblioteca de recursos",
   "collections-tab-label": "Coleções",
   "workspace-breadcrumb-label": "Espaço de trabalho",
   "resources-breadcrumb-label": "Recursos",
   "results-breadcrumb-label": "Resultados",
   "action-plan-breadcrumb-label": "Plano de ação",
   "respondents-count-label": "respondentes",
   "of-word": "de",
   "copy-tasks-title": "Copiar tarefas",
   "copy-tasks-description-text":
      "Todas as tarefas da sua ronda anterior serão copiadas para garantir que o seu plano de ação se mantém completo à medida que evolui.",
   "previous-round-label": "Ronda anterior:",
   "tasks-copied-label": "Tarefas copiadas",
   "task-statistics-fetch-error": "Ocorreu um problema ao carregar as estatísticas das tarefas, tente novamente.",
   "delete-note-confirm-text":
      "Está prestes a eliminar esta nota de revisão. Esta ação não pode ser anulada.",
   "delete-view-title": "Eliminar vista",
   "delete-view-confirm-text": "Está prestes a eliminar esta vista. Esta ação não pode ser anulada.",
   "rename-view-title": "Mudar o nome da vista",
   "save-button": "Guardar",
   "select-a-resource-title": "Selecionar um recurso",
   "set-a-reminder-title": "Definir um lembrete",
   "reminder-description-text":
      "Escolha quando pretende ser lembrado de adicionar ou atualizar as notas de progresso da sua equipa.",
   "reminder-type-label": "Tipo de lembrete",
   "select-reminder-type-required-validation": "Selecione um tipo de lembrete",
   "select-day-required-validation": "Selecione um dia",
   "select-a-day-placeholder": "Selecione um dia",
   "reminder-repeat-prefix-text":
      "Esta será a data do seu primeiro lembrete. Os lembretes futuros repetir-se-ão a cada",
   "repeat-interval-week": "semana",
   "repeat-interval-2-weeks": "2 semanas",
   "repeat-interval-month": "mês",
   "repeat-interval-3-months": "3 meses",
   "repeat-interval-year": "ano",
   "reminder-repeat-suffix-text": "no mesmo dia.",
   "next-reminder-date-label": "Data do próximo lembrete:",
   "save-reminder-button": "Guardar lembrete",
   "my-workspaces-tab": "Os meus espaços de trabalho",
   "all-workspaces-tab": "Todos os espaços de trabalho",
   "fetch-workspaces-error-description": "Ocorreu um problema ao obter os espaços de trabalho, tente novamente.",
   "archived-workspaces-title": "Espaços de trabalho arquivados",
   "deleted-workspaces-button": "Espaços de trabalho eliminados",
   "new-workspace-button": "Novo espaço de trabalho",
   "remove-action": "Remover",
   "workspace-name-label": "Nome do espaço de trabalho",
   "enter-workspace-name-placeholder": "Introduza o nome do seu espaço de trabalho",
   "workspace-description-label": "Descrição do espaço de trabalho",
   "enter-workspace-description-placeholder": "Introduza a descrição do espaço de trabalho",
   "workspace-countries-label": "Países do espaço de trabalho",
   "select-a-country-placeholder": "Selecione um país",
   "workspace-assessment-label": "Avaliação do espaço de trabalho",
   "select-default-assessment-survey-placeholder": "Selecione a avaliação predefinida do questionário",
   "select-default-assessment-module-placeholder": "Selecione a avaliação predefinida do módulo",
   "workspace-duplicate-name-validation": "Este espaço de trabalho já existe. Tente outro.",
   "workspace-created-success-title": "Espaço de trabalho criado com sucesso!",
   "workspace-created-success-description":
      "Foi criado um novo espaço de trabalho e adicionado à sua base de dados",
   "create-workspace-error-description": "Ocorreu um problema ao criar este espaço de trabalho, tente novamente.",
   "add-new-workspace-title": "Adicionar novo espaço de trabalho",
   "workspace-updated-success-title": "Espaço de trabalho atualizado com sucesso!",
   "workspace-updated-success-description": "Este espaço de trabalho foi atualizado com sucesso.",
   "update-workspace-error-description": "Ocorreu um problema ao atualizar este espaço de trabalho, tente novamente.",
   "edit-workspace-title": "Editar espaço de trabalho",
   "at-least-one-assessment-required-validation": "É obrigatória pelo menos uma avaliação",
   "workspace-archived-success-title": "Espaço de trabalho arquivado com sucesso!",
   "workspace-archived-success-description": "Este espaço de trabalho foi arquivado com sucesso.",
   "archive-workspace-error-description": "Ocorreu um problema ao arquivar este espaço de trabalho, tente novamente.",
   "archive-workspace-title": "Arquivar espaço de trabalho",
   "archive-workspace-confirm-text": "Está prestes a arquivar este espaço de trabalho.",
   "workspace-deleted-success-title": "Espaço de trabalho eliminado com sucesso!",
   "workspace-deleted-success-description": "Este espaço de trabalho foi removido com sucesso.",
   "delete-workspace-error-description": "Ocorreu um problema ao eliminar este espaço de trabalho, tente novamente.",
   "delete-workspace-title": "Eliminar espaço de trabalho",
   "delete-workspace-confirm-text": "Está prestes a eliminar este espaço de trabalho.",
   "workspace-restored-success-title": "Espaço de trabalho restaurado com sucesso!",
   "restore-workspace-error-description": "Ocorreu um problema ao restaurar este espaço de trabalho, tente novamente.",
   "workspace-deleted-permanently-success-description":
      "Este espaço de trabalho foi eliminado com sucesso da sua base de dados.",
   "restore-assessment-error-description": "Ocorreu um problema ao restaurar esta avaliação, tente novamente.",
   "restore-workspaces-button": "Restaurar espaços de trabalho",
   "delete-workspace-permanently-title": "Eliminar espaço de trabalho definitivamente",
   "delete-workspace-permanently-confirm-text":
      "Está prestes a eliminar definitivamente este espaço de trabalho. Esta ação não pode ser anulada.",
   "workspaces-unarchived-success-title": "Espaços de trabalho desarquivados com sucesso!",
   "workspaces-unarchived-success-description":
      "Estes espaços de trabalho foram desarquivados e adicionados à sua base de dados.",
   "unarchive-workspace-error-description": "Ocorreu um problema ao desarquivar este espaço de trabalho, tente novamente.",
   "workspaces-deleted-success-title": "Espaços de trabalho eliminados com sucesso!",
   "workspaces-deleted-success-description": "Estes espaços de trabalho foram eliminados da sua base de dados.",
   "deleted-workspaces-list-title": "Lista de espaços de trabalho eliminados",
   "deleted-workspaces-retention-text":
      "Aqui pode consultar e restaurar os espaços de trabalho eliminados. Qualquer espaço de trabalho que não seja restaurado no prazo de 60 dias será eliminado definitivamente.",
   "request-canceled-success-title": "Pedido cancelado com sucesso!",
   "request-canceled-success-description": "O seu pedido foi cancelado.",
   "cancel-request-error-description": "Ocorreu um problema ao cancelar este pedido, tente novamente.",
   "cancel-request-button": "Cancelar pedido",
   "send-request-success-description":
      "O seu pedido foi enviado ao administrador. Assim que o pedido for respondido, receberá um e-mail.",
   "send-request-error-description": "Ocorreu um problema ao enviar o seu pedido, tente novamente.",
   "no-workspaces-here-title": "Não existem espaços de trabalho aqui!",
   "request-part-workspace-description":
      "Mas não se preocupe, pode pedir para fazer parte de um espaço de trabalho na secção “Todos os espaços de trabalho”.",
   "go-to-all-workspaces-button": "Ir para Todos os espaços de trabalho",
   "create-workspaces-tagline-text":
      "Crie espaços de trabalho adaptados para promover o crescimento e a otimização das organizações.",
   "export-workspaces-button": "Exportar espaços de trabalho",
   "all-workspaces-consultant-heading": "Todos os espaços de trabalho",
   "assess-partners-consultant-description":
      "Comece a avaliar parceiros/ONG locais e forneça-lhes um relatório detalhado do seu desempenho atual.",
   "access-workspace-organization-text": "Aceda a um espaço de trabalho e comece a avaliar a sua organização.",
   "no-workspace-created-yet-description":
      "Parece que ainda não criou nenhum espaço de trabalho. Mas não se preocupe, pode criá-los aqui.",
   "untitled-label": "Sem título",
   "no-section-label": "Sem secção",
   "swot-analysis-title": "Análise SWOT",
   "swot-analysis-subtitle-text": "Analise os pontos fortes, os pontos fracos, as oportunidades e as ameaças",
   "related-module-label": "Módulo relacionado",
   "select-module-placeholder": "Selecione o módulo",
   "enter-analysis-description-placeholder": "Introduza a descrição da análise",
   "swot-strengths-title": "Pontos fortes",
   "swot-weaknesses-title": "Pontos fracos",
   "swot-opportunities-title": "Oportunidades",
   "swot-threats-title": "Ameaças",
   "related-sections-label": "Secções relacionadas",
   "select-sections-placeholder": "Selecione as secções",
   "analysis-label": "Análise",
   "describe-strengths-placeholder": "Descreva os pontos fortes",
   "describe-weaknesses-placeholder": "Descreva os pontos fracos",
   "describe-opportunities-placeholder": "Descreva as oportunidades",
   "describe-threats-placeholder": "Descreva as ameaças",
   "add-analysis-button": "Adicionar análise",
   "scores-label": "Pontuações",
   "guided-assessment-label": "Avaliação guiada",
   "self-assessment-label": "Autoavaliação",
   "highlights-title": "Destaques",
   "highlights-subtitle-text": "Destaque as principais conclusões e apresente recomendações com base nos resultados",
   "choose-chart-analyze-label": "Escolha o gráfico que pretende analisar",
   "select-chart-analyze-text": "Selecione o gráfico que pretende analisar",
   "change-button": "Alterar",
   "select-a-module-first-placeholder": "Selecione primeiro um módulo",
   "add-comparison-label": "Adicionar comparação",
   "insight-label": "Perspetiva",
   "max-400-characters-validation": "Máximo 400 caracteres",
   "describe-key-points-placeholder": "Descreva os pontos-chave que pretende destacar neste gráfico...",
   "select-chart-to-analyze-title": "Selecione um gráfico para analisar",
   "choose-chart-from-list-text": "Escolha um dos gráficos disponíveis na lista para análise.",
   "report-title": "Relatório",
   "upload-report-insights-text":
      "Carregue o seu relatório para que passe a fazer parte das perspetivas desta avaliação.",
   "upload-file-here-label": "Carregue aqui o ficheiro",
   "current-file-text": "Ficheiro atual",
   "remove-file-aria-label": "Remover ficheiro",
   "doc-pdf-pptx-text": "DOC, PDF ou PPTX",
   "only-doc-pdf-pptx-error": "Apenas são permitidos ficheiros DOC, PDF ou PPTX.",
   "file-must-be-smaller-than-prefix": "O ficheiro tem de ser inferior a",
   "missing-assessment-org-warning": "Faltam os dados da avaliação ou da organização.",
   "upload-report-file-warning": "Carregue um ficheiro de relatório.",
   "title-required-validation": "O título é obrigatório",
   "ticket-type-required-validation": "O tipo de ticket é obrigatório",
   "message-required-validation": "A mensagem é obrigatória",
   "ticket-added-success-title": "Ticket adicionado com sucesso!",
   "ticket-added-success-description":
      "Este ticket foi adicionado com sucesso à base de dados do seu histórico de tickets; alguém responderá ao seu pedido muito em breve.",
   "add-ticket-error-description": "Ocorreu um problema ao adicionar este ticket, tente novamente.",
   "upload-jpg-png-gif-webp-error": "Carregue apenas ficheiros JPG, PNG, GIF ou WEBP.",
   "add-new-ticket-title": "Adicionar um novo ticket",
   "ticket-type-label": "Tipo de ticket",
   "select-ticket-type-placeholder": "Selecione o tipo de ticket",
   "summary-label": "Resumo",
   "enter-title-placeholder": "Introduza o título",
   "describe-problem-detail-label": "Descreva o problema em detalhe",
   "type-something-placeholder": "Escreva algo aqui",
   "attach-evidence-label": "Anexe qualquer evidência que considere importante",
   "jpg-png-gif-webp-text": "JPG, PNG, GIF e WEBP",
   "add-ticket-button": "Adicionar ticket",
   "tickets-deleted-success-title": "Os tickets selecionados foram eliminados com sucesso!",
   "tickets-deleted-success-description": "Estes tickets selecionados foram eliminados com sucesso",
   "delete-tickets-error-description":
      "Ocorreu um problema ao eliminar estes tickets selecionados, tente novamente.",
   "delete-selected-tickets-title": "Eliminar tickets selecionados",
   "delete-selected-tickets-confirm-text": "Está prestes a eliminar estes tickets selecionados.",
   "collection-updated-success-title": "Coleção atualizada com sucesso!",
   "collection-updated-success-description": "Esta coleção foi atualizada corretamente.",
   "update-collection-error-description": "Ocorreu um problema ao atualizar esta coleção, tente novamente.",
   "collection-added-success-title": "Coleção adicionada com sucesso!",
   "collection-added-success-description":
      "Esta coleção foi criada e adicionada à sua base de dados.",
   "add-collection-error-description": "Ocorreu um problema ao adicionar esta coleção, tente novamente.",
   "edit-collection-title": "Editar coleção",
   "add-new-collection-title": "Adicionar nova coleção",
   "new-collection-button-label": "Nova coleção",
   "name-collection-label": "Nome da coleção",
   "enter-collection-name-placeholder": "Introduza o nome da coleção",
   "enter-collection-description-placeholder": "Introduza a descrição da coleção",
   "select-the-assessment-label": "Selecione a avaliação",
   "select-resources-collection-placeholder": "Selecione os recursos associados a esta coleção",
   "see-more-text": "Ver mais",
   "make-collection-public-label": "Tornar esta coleção pública e visível para todos",
   "add-collection-button": "Adicionar coleção",
   "global-status": "Global",
   "owner-colon-label": "Proprietário:",
   "resources-colon-label": "Recursos:",
   "resource-added-collection-success-title": "Recurso adicionado à coleção!",
   "resource-added-collection-success-description":
      "Este recurso foi adicionado com sucesso à coleção.",
   "add-resource-collection-error-description":
      "Ocorreu um problema ao adicionar este recurso à coleção, tente novamente.",
   "add-to-collection-title": "Adicionar à coleção",
   "resource-updated-success-title": "Recurso atualizado com sucesso!",
   "resource-updated-success-description":
      "Este recurso foi atualizado corretamente. Foi criada uma nova versão",
   "update-resource-error-description": "Ocorreu um problema ao atualizar este recurso, tente novamente.",
   "resource-added-success-title": "Recurso adicionado com sucesso!",
   "resource-added-success-description":
      "Este recurso foi criado e adicionado à sua base de dados.",
   "add-resource-error-description": "Ocorreu um problema ao adicionar este recurso, tente novamente.",
   "edit-resource-title": "Editar recurso",
   "select-resource-type-label": "Selecione o tipo de recurso",
   "select-resource-type-required-validation": "Selecione o tipo de recurso",
   "video-placeholder-text": "Vídeo",
   "select-type-before-upload-text": "Antes de carregar um recurso tem de selecionar o seu tipo",
   "enter-resource-link-label": "Introduza aqui o link do recurso",
   "valid-url-required-validation": "Introduza um URL válido",
   "enter-resource-link-placeholder": "Introduza o link do seu recurso",
   "select-a-file-required-validation": "Selecione um ficheiro",
   "click-to-select-files-text": "clique para selecionar ficheiros",
   "resource-version-colon-label": "Versão do recurso:",
   "make-resource-private-label": "Tornar este recurso privado",
   "resource-name-label": "Nome do recurso",
   "enter-resource-name-placeholder": "Introduza o nome do recurso",
   "tags-label": "Etiquetas",
   "enter-resource-tags-placeholder": "Introduza os tópicos com os quais este recurso pode estar relacionado",
   "select-module-label": "Selecione o módulo",
   "select-section-label": "Selecione a secção",
   "upload-consent-text":
      "Qualquer recurso que carregue será armazenado no repositório da KAPorg de acordo com a visibilidade que escolher, ficando disponível para o público selecionado. Ao prosseguir, confirma que possui os direitos e as permissões necessários para carregar este material.",
   "add-resource-button": "Adicionar recurso",
   "file-label": "Ficheiro",
   "views-suffix": "Visualizações",
   "rating-suffix": "Classificação",
   "owner-label": "Proprietário",
   "visibility-label": "Visibilidade",
   "linked-to-label": "Associado a",
   "last-update-date-label": "Data da última atualização",
   "resource-version-label": "Versão do recurso",
   "targets-updated-success-title": "Metas atualizadas com sucesso!",
   "targets-updated-success-description": "Todas as alterações foram guardadas com sucesso.",
   "save-targets-error-description": "Ocorreu um problema ao guardar todas as alterações, tente novamente.",
   "current-target-label": "Meta atual:",
   "no-active-rounds-text": "Sem rondas ativas",
   "no-target-set-yet-text": "Ainda não foi definida nenhuma meta",
   "no-assessments-found-text": "Não foram encontradas avaliações",
   "no-modules-yet-title": "Ainda não existem módulos",
   "no-modules-assigned-description":
      "Esta avaliação não tem módulos atribuídos. Aparecerão aqui assim que forem adicionados.",
   "enter-target-placeholder": "Introduza a meta",
   "ticket-history-title": "Histórico de tickets",
   "help-desk-title": "Balcão de apoio",
   "delete-selected-rows-text": "Eliminar linhas selecionadas",
   "add-new-ticket-text": "Novo ticket",
   "subject-column": "Assunto",
   "creation-date-column": "Data de criação",
   "organization-column": "Organização",
   "last-response-column": "Última resposta",
   "ticket-preview-title": "Pré-visualização do ticket",
   "ticket-status-closed": "Fechado",
   "ticket-summary-title": "Resumo do ticket",
   "user-email-label": "E-mail do utilizador",
   "ticket-subject-label": "Assunto do ticket",
   "mark-as-resolved-button": "Fechar ticket",
   "mark-ticket-resolved-title": "Fechar este ticket?",
   "mark-ticket-resolved-confirm-text": "Tem a certeza de que deseja fechar este ticket? A organização ainda pode responder se precisar de mais ajuda.",
   "ticket-resolved-success-title": "Ticket fechado",
   "ticket-resolved-success-description": "O ticket foi fechado.",
   "resolve-ticket-error-description": "Ocorreu um erro ao fechar o ticket. Por favor, tente novamente.",
   "type-your-message-placeholder": "Escreva aqui a sua mensagem...",
   "filter-tickets-by-type-placeholder": "Filtrar por tipo",
   "filter-tickets-by-status-placeholder": "Filtrar por estado",
   "summary-results-title": "Resumo dos resultados",
   "graphs-view-tab": "Vista de gráficos",
   "table-view-tab": "Vista de tabela",
   "expert-insights-tab": "Perspetivas dos especialistas",
   "no-dashboard-results-yet-title": "Este painel ainda não tem resultados",
   "results-appear-here-description": "Assim que existirem dados, os seus resultados aparecerão aqui.",
   "submission-round-column": "Ronda de submissão",
   "submission-label-column": "Etiqueta da submissão",
   "select-module-first-text": "Selecione primeiro um módulo.",
   "select-at-least-one-submission-round-text": "Selecione pelo menos uma ronda de submissão.",
   "unable-detect-organization-text": "Não foi possível detetar a sua organização. Inicie sessão novamente.",
   "download-table-label": "Transferir tabela",
   "score-overview-title": "Visão geral da pontuação",
   "toggle-score-overview-aria-label": "Alternar visão geral da pontuação",
   "visualizations-title": "Visualizações",
   "search-a-graph-placeholder": "Procurar um gráfico",
   "select-view-placeholder": "Selecionar vista",
   "save-view-button": "Guardar vista",
   "save-dashboard-button": "Guardar painel",
   "edit-dashboard-button": "Editar painel",
   "download-dashboard-label": "Transferir painel",
   "round-label": "Ronda",
   "manager-label": "Gestor",
   "select-an-organization-placeholder": "Selecione uma organização",
   "select-all-option": "Selecionar tudo",
   "all-placeholder": "Todos",
   "score-percent-label": "Pontuação (%)",
   "task-completion-percent-label": "Conclusão de tarefas (%)",
   "task-status-percent-label": "Estado das tarefas (%)",
   "value-label": "Valor",
   "first-round-label": "Primeira ronda",
   "second-round-label": "Segunda ronda",
   "improvement-percent-label": "Melhoria %",
   "result-label": "Resultado",
   "current-label": "Atual",
   "target-word": "Meta",
   "overall-score-label": "Pontuação global",
   "of-tasks-completed-label": "das tarefas concluídas",
   "leading-label": "Avançado",
   "developing-label": "Em desenvolvimento",
   "lagging-label": "Em atraso",
   "section-word": "Secção",
   "task-completion-label": "Conclusão de tarefas",
   "indicator-word": "Indicador",
   "progress-word": "Progresso",
   "current-round-label": "Ronda atual:",
   "change-label": "Variação:",
   "improvement-label": "Melhoria",
   "task-count-label": "Número de tarefas",
   "assessment-results-per-module-title": "Resultados da avaliação por módulo",
   "assessment-results-per-section-title": "Resultados da avaliação por secção",
   "performance-map-title": "Mapa de desempenho",
   "assessment-results-per-organization-title": "Resultados da avaliação por organização",
   "module-results-per-organization-title": "Resultados do módulo por organização",
   "section-results-per-organization-title": "Resultados da secção por organização",
   "assessment-targets-per-organization-title": "Metas da avaliação por organização",
   "module-targets-per-organization-title": "Metas do módulo por organização",
   "section-targets-per-organization-title": "Metas da secção por organização",
   "improvement-tracker-per-organization-title": "Monitorização da melhoria por organização",
   "target-score-task-progress-per-organization-title": "Meta, pontuação e progresso das tarefas por organização",
   "assessment-results-per-round-title": "Resultados da avaliação por ronda",
   "module-results-per-round-title": "Resultados do módulo por ronda",
   "section-results-per-round-title": "Resultados da secção por ronda",
   "assessment-targets-per-round-title": "Metas da avaliação por ronda",
   "module-targets-per-round-title": "Metas do módulo por ronda",
   "section-targets-per-round-title": "Metas da secção por ronda",
   "improvement-tracker-per-assessment-title": "Monitorização da melhoria por avaliação",
   "target-score-task-progress-per-assessment-title": "Meta, pontuação e progresso das tarefas por avaliação",
   "radar-chart-type-label": "Gráfico de radar",
   "tier-list-type-label": "Lista de níveis",
   "score-progress-across-rounds-title": "Progresso da pontuação ao longo das rondas",
   "module-score-progress-across-rounds-title": "Progresso da pontuação por módulo ao longo das rondas",
   "bar-chart-type-label": "Gráfico de barras",
   "table-type-label": "Tabela",
   "modules-word": "Módulos",
   "sections-word": "Secções",
   "task-status-per-assessment-title": "Estado das tarefas por avaliação",
   "module-task-completion-title": "Conclusão de tarefas do módulo",
   "section-task-completion-title": "Conclusão de tarefas da secção",
   "task-completion-per-organization-title": "Conclusão de tarefas por organização",
   "improvement-tracker-title": "Monitorização da melhoria",
   "donut-chart-type-label": "Gráfico de anel",
   "task-updated-success-message": "Tarefa atualizada com sucesso.",
   "task-added-success-message": "Tarefa adicionada com sucesso.",
   "export-tasks-error-message": "Ocorreu um problema ao exportar as tarefas, tente novamente.",
   "tasks-copied-success-title": "Tarefas copiadas com sucesso!",
   "tasks-copied-success-description": "Todas as tarefas da ronda anterior foram copiadas para a ronda atual.",
   "results-not-yet-approved-title": "Os resultados ainda não foram aprovados!",
   "results-not-yet-approved-description": "As tarefas só podem ser copiadas quando todos os módulos desta avaliação tiverem submissões aprovadas. Aprove as suas submissões antes de copiar as tarefas.",
   "tasks-already-copied-title": "As tarefas já foram copiadas para esta ronda",
   "tasks-already-copied-description": "As tarefas só podem ser copiadas uma vez por ronda. Se lhe faltarem tarefas, contacte o seu administrador.",
   "copy-tasks-error-title": "Ups! Ocorreu um problema!",
   "copy-tasks-error-description": "Ocorreu um problema ao copiar as tarefas da ronda anterior, tente novamente.",
   "resource-label-colon": "Recurso:",
   "edit-module-alt-text": "Editar módulo",
   "delete-module-alt-text": "Eliminar módulo",
   "task-status-updated-message": "Estado da tarefa atualizado.",
   "failed-update-task-status-message": "Falha ao atualizar o estado da tarefa.",
   "plan-summary-title": "Resumo do plano",
   "select-organization-to-view-plan-text": "Selecione uma organização acima para ver o resumo do seu plano.",
   "select-organization-placeholder": "Selecionar organização",
   "previous-round-readonly-notice-text": "Esta é uma ronda anterior e é apenas de leitura para preservar os seus dados. Só pode efetuar alterações na ronda atual.",
   "viewing-previous-round-button": "Está a visualizar uma ronda anterior",
   "go-to-current-round-button": "Ir para a ronda atual",
   "staff-member-label": "Colaborador",
   "export-plan-button": "Exportar plano",
   "task-column-header": "Tarefa",
   "responsible-column-header": "Responsável",
   "due-date-column-header": "Data limite",
   "see-less-link": "Ver menos",
   "see-all-link": "Ver tudo",
   "no-linked-questions-text": "Sem perguntas associadas",
   "resources-label-colon": "Recursos:",
   "no-tasks-for-staff-member-text": "Não foram encontradas tarefas para o colaborador selecionado",
   "add-tasks-improve-score-text": "Adicione tarefas a este indicador para melhorar a sua pontuação",
   "result-label-colon": "Resultado:",
   "target-label-colon": "Meta:",
   "review-note-added-success-description": "A nota de revisão foi adicionada com sucesso.",
   "reminder-set-title": "Lembrete definido",
   "reminder-scheduled-success-description": "O seu lembrete foi agendado com sucesso.",
   "review-notes-title": "Notas de revisão",
   "set-reminder-button": "Definir lembrete",
   "print-summary-button": "Imprimir resumo",
   "export-notes-button": "Exportar notas",
   "note-word": "Nota",
   "no-note-created-yet-text": "Ainda não foi criada nenhuma nota.",
   "no-review-notes-available-text": "Não existem notas de revisão disponíveis.",
   "no-score-selected-text": "Nenhuma pontuação selecionada",
   "filters-colon-label": "Filtros:",
   "none-word": "Nenhum",
   "graph-word": "Gráfico",
   "no-chart-content-text": "Sem conteúdo de gráfico",
   "filter-colon-label": "Filtro:",
   "action-plan-word": "Plano de ação",
   "results-word": "Resultados",
   "no-charts-available-title": "Não existem gráficos disponíveis",
   "no-charts-data-export-text": "Não existem gráficos com dados disponíveis para exportação.",
   "summary-action-plan-dashboard-title": "Painel de resumo do plano de ação",
   "summary-results-dashboard-title": "Painel de resumo dos resultados",
   "assessment-colon-label": "Avaliação:",
   "assessment-word": "Avaliação",
   "download-svg-action": "Transferir SVG",
   "download-png-action": "Transferir PNG",
   "included-in-report-tooltip-text": "Incluído ao gerar o relatório",
   "no-visualization-selected-text": "Nenhuma visualização selecionada",
   "drop-visualization-here-text": "Largue aqui a visualização",
   "add-graph-button": "Adicionar gráfico",
   "delete-block-tooltip-text": "Excluir bloco",
   "no-filters-selected-text": "Nenhum filtro selecionado",
   "filters-word": "Filtros",
   "untitled-graph-text": "Gráfico sem título",
   "graph-preview-unavailable-text": "Pré-visualização do gráfico indisponível",
   "filter-word": "Filtro",
   "global-suffix-label": "(global)",
   "organization-word": "Organização",
   "staff-word": "Pessoal",
   "generic-problem-occurred-title": "Ups! Ocorreu um problema",
   "view-saved-success-title": "Vista guardada com sucesso!",
   "view-saved-success-description": "A vista do seu painel foi guardada com sucesso.",
   "problem-saving-view-description": "Ocorreu um problema ao guardar esta vista, tente novamente.",
   "select-view-before-rename-text": "Selecione uma vista antes de mudar o nome.",
   "select-view-before-delete-text": "Selecione uma vista antes de eliminar.",
   "view-deleted-success-title": "Vista eliminada com sucesso!",
   "view-deleted-success-description": "A vista selecionada foi eliminada do seu painel.",
   "problem-deleting-view-description": "Ocorreu um problema ao eliminar esta vista, tente novamente.",
   "view-renamed-success-title": "Nome da vista alterado com sucesso!",
   "view-renamed-success-description": "O nome da vista selecionada foi atualizado com sucesso.",
   "problem-renaming-view-description": "Ocorreu um problema ao mudar o nome desta vista, tente novamente.",
   "view-word": "Vista",
   "compare-with-self-assessment-label": "Comparar com a autoavaliação",
   "comparison-limited-one-org-text": "Esta comparação está limitada a uma organização de cada vez",
   "assessment-not-linked-self-text": "Esta avaliação não está associada a uma autoavaliação",
   "dashboard-word": "Painel",
   "self-assessments-menu-item": "Autoavaliações",
   "guided-assessments-menu-item": "Avaliações guiadas",
   "module-request-menu-item": "Pedido de módulo",
   "action-plan-menu-item": "Plano de ação",
   "my-performance-menu-item": "O meu desempenho",
   "task-management-menu-item": "Gestão de tarefas",
   "resources-menu-item": "Recursos",
   "organization-management-menu-item": "Gestão da organização",
   "quick-search-tooltip-text": "Pesquisa rápida",
   "notifications-tooltip-text": "Notificações",
   "help-desk-word": "Balcão de apoio",
   "go-back-previous-menu-text": "Voltar ao menu anterior",
   "go-back-to-action-plan-link": "Voltar ao plano de ação",
   "go-back-to-module-list-link": "Voltar à lista de módulos",
   "go-back-to-modules-list-link": "Voltar à lista de módulos",
   "go-back-to-templates-list-link": "Voltar à lista de modelos",
   "go-back-to-action-plan-section-link": "Voltar à secção do plano de ação",
   "go-back-to-assessment-link": "Voltar à avaliação",
   "go-back-to-assessments-link": "Voltar às avaliações",
   "go-back-to-assigned-modules-list-link": "Voltar à lista de módulos atribuídos",
   "go-back-to-approved-modules-list-link": "Voltar à lista de módulos aprovados",
   "go-back-to-pending-modules-list-link": "Voltar à lista de módulos pendentes",
   "go-back-to-guided-assessment-link": "Voltar à avaliação guiada",
   "go-back-to-guided-assessment-list-link": "Voltar à lista de avaliações guiadas",
   "go-back-to-workspaces-link": "Voltar aos espaços de trabalho",
   "profile-preview-alt-text": "Pré-visualização do perfil",
   "org-role-abbreviation": "Org",
   "role-super-admin-label": "Super Administrador",
   "role-consultant-label": "Consultor",
   "role-donor-label": "Doador",
   "role-national-organization-label": "Organização Nacional",
   "role-international-organization-label": "Organização Internacional",
   "male-label": "Masculino",
   "female-label": "Feminino",
   "no-self-assessments-here-text": "Não existem autoavaliações aqui",
   "no-guided-assessments-here-text": "Não existem avaliações guiadas aqui",
   "self-assessment-panel-title": "Autoavaliação",
   "guided-assessment-panel-title": "Avaliação guiada",
   "sort-progress-by-label": "Ordenar progresso por:",
   "highest-to-lowest-option": "Do mais alto para o mais baixo",
   "lowest-to-highest-option": "Do mais baixo para o mais alto",
   "modules-count-suffix": "módulos",
   "answer-pending-status": "Resposta pendente",
   "unlock-assessment-text": "Desbloquear avaliação",
   "select-assessment-see-results-text": "Selecione uma avaliação para ver os seus resultados em detalhe.",
   "linked-badge-label": "Associada",
   "no-assessments-available-title": "Não existem avaliações disponíveis.",
   "start-adding-view-results-text": "Comece por adicionar uma para ver os resultados recolhidos.",
   "assessment-selected-suffix": "avaliação selecionada",
   "action-plan-panel-description-text": "Aqui encontrará um plano de ação baseado nos seus resultados em cada avaliação.",
   "select-one-see-plan-detail-text": "Selecione um para ver o plano em detalhe.",
   "search-for-assessment-placeholder": "Procurar uma avaliação",
   "areas-to-improve-label": "Módulos a melhorar:",
   "no-assessments-here-text": "Não existem avaliações aqui!",
   "selected-assessment-title": "Avaliação selecionada",
   "no-assessment-selected-text": "Nenhuma avaliação selecionada",
   "number-of-resources-label": "Número de recursos:",
   "areas-in-label": "Áreas:",
   "indicators-to-improve-label": "Indicadores a melhorar:",
   "no-data-available-to-display-text": "Não existem dados disponíveis para apresentar.",
   "self-evaluate-screen-description-text": "Este ecrã permite-lhe avaliar-se com base nos questionários que preencheu",
   "maximum-organizations-warning-text": "Máximo 5 organizações!",
   "search-organization-placeholder": "Procurar organização",
   "sort-order-tooltip-text": "Ordenação",
   "get-results-tooltip-text": "Obter resultados",
   "report-word": "Relatório",
   "capacity-gaps-title": "Lacunas de capacidade",
   "capacity-gaps-description-text": "Que módulos e secções estão fortes e quais estão fracos, e qual o seu desempenho face às respetivas metas.",
   "performance-overview-title": "Visão geral do desempenho",
   "performance-overview-description-text": "Onde se situa o grupo nesta ronda: as pontuações das organizações, como se distribuem pelas categorias de pontuação da avaliação e como se posicionam face à meta da ronda.",
   "progress-across-rounds-title": "Progresso ao longo das rondas",
   "progress-across-rounds-description-text": "Onde o grupo se situou nesta ronda ao nível das secções e como cada organização evoluiu desde a ronda anterior — quem melhorou, quem regrediu e em que medida.",
   "action-plan-status-title": "Estado do plano de ação",
   "action-plan-status-description-text": "Conclusão das tarefas por organização na ronda selecionada e a sua relação com o cumprimento das metas.",
   "score-band-deficient": "Deficiente",
   "score-band-insufficient": "Insuficiente",
   "score-band-satisfactory": "Satisfatório",
   "score-band-very-good": "Muito bom",
   "score-band-excellent": "Excelente",
   "module-rejected-success-description": "Módulo rejeitado com sucesso",
   "failed-reject-module-description": "Falha ao rejeitar este módulo",
   "module-accepted-success-description": "Módulo aceite com sucesso",
   "failed-accept-module-description": "Falha ao aceitar este módulo",
   "module-requests-title": "Pedidos de módulo",
   "pending-modules-review-description-text": "Esta é a lista de módulos pendentes de revisão. Para continuar, clique em cada módulo, onde poderá aceitá-lo ou rejeitá-lo.",

   // Login / Registration pages
   "welcome-back-title": "Bem-vindo de volta!",
   "login-into-account-subtitle": "Inicie sessão na sua conta",
   "email-placeholder": "yourmail@gmail.com",
   "password-label": "Palavra-passe",
   "toggle-password-visibility-label": "Mostrar/ocultar palavra-passe",
   "remember-me-label": "Lembrar-me?",
   "log-in-button": "Iniciar sessão",
   "no-account-yet-text": "Ainda não tem conta?",
   "sign-up-link": "Criar conta",
   "max-16-symbols-validation": "Máximo de 16 carateres",
   "go-back-icon-alt": "Voltar",
   "go-back-to-login-link": "Voltar ao início de sessão",
   "welcome-to-kaporg-title": "Bem-vindo ao KAPorg!",
   "which-profile-title": "Que perfil o descreve melhor?",
   "profile-organization-label": "Organização",
   "profile-donors-label": "Doadores",
   "profile-expert-label": "Especialista",
   "signup-role-title": "Como você vai usar o KAPorg?",
   "signup-role-subtitle": "Escolha a função que melhor corresponde às suas responsabilidades.",
   "profile-donor-label": "Doador",
   "signup-role-organization-description": "Desenvolver capacidade organizacional sustentável",
   "signup-role-donor-description": "Supervisionar o desempenho do portfólio institucional",
   "signup-role-expert-description": "Oferecer orientação estratégica independente",
   "signup-create-account-as-an": "Criar uma conta como",
   "signup-create-account-as-a": "Criar uma conta como",
   "showcase-login-headline": "Capacitamos organizações para liderar [[o desenvolvimento de capacidades]]",
   "showcase-organization-headline": "Avalie suas capacidades e [[amplie sua missão]]",
   "showcase-donor-headline": "Supervisione o desempenho do portfólio e [[gere resultados mensuráveis]]",
   "showcase-expert-headline": "Ofereça orientação estratégica e [[eleve a capacidade institucional]]",
   "signup-step-profile": "Perfil",
   "signup-step-expertise": "Especialidade",
   "profile-details-title": "Detalhes do perfil",
   "upload-photo-text": "Carregar foto",
   "adjust-your-photo-title": "Ajuste sua foto",
   "change-photo-text": "Alterar foto",
   "signup-step-account": "Conta",
   "signup-step-contact": "Contato",
   "enter-organization-email-placeholder": "Digite o e-mail da organização",
   "code-must-have-6-digits-validation": "O código deve ter 6 dígitos",
   "code-incorrect-text": "O código está incorreto",
   "confirmation-email-shortly-text": "Você receberá um e-mail de confirmação em breve",
   "go-to-homepage-button": "Ir para a página inicial",
   "didnt-get-email-text": "Não recebeu o e-mail? Verifique a pasta de spam ou escreva para",
   "language-selector-label": "Selecionar idioma",
   "auth-tagline-transforming-title": "Transformar o desenvolvimento de capacidades",
   "auth-tagline-transforming-description": "Para a era digital",
   "auth-tagline-elevate-title": "Eleve a sua organização",
   "auth-tagline-elevate-description": "com uma avaliação com propósito!",
   "auth-tagline-changemakers-title": "Ligue-se aos agentes de mudança",
   "auth-tagline-changemakers-description": "que mais precisam de si.",
   "auth-tagline-miss-you-title": "Vamos sentir a sua falta,",
   "auth-tagline-miss-you-description": "Esperamos vê-lo(a) regressar em breve.",
   "auth-tagline-collaborations-title": "Mergulhe num mundo",
   "auth-tagline-collaborations-description": "de colaborações com impacto!",
   "auth-tagline-expertise-title": "A sua experiência",
   "auth-tagline-expertise-description": "e as suas perspetivas impulsionam o progresso!",

   // National organization registration form
   "go-back-to-profile-selection-link": "Voltar à seleção de perfil",
   "create-account-title": "Criar uma conta",
   "as-an-org-label": "como Organização",
   "login-details-title": "Dados de início de sessão",
   "confirm-password-label": "Confirmar palavra-passe",
   "type-description-placeholder": "Escreva uma descrição",
   "working-sectors-label": "Setores de atuação",
   "enter-organization-name-placeholder": "Introduza o nome da organização",
   "enter-organization-address-placeholder": "Introduza o endereço da organização",
   "enter-organization-zip-code-placeholder": "Introduza o código postal da organização",
   "terms-agreement-prefix-text": "Li e concordo com os",
   "terms-of-service-privacy-policy-link": "Termos de Serviço, Política de Privacidade",
   "and-conjunction-text": "e",
   "cookie-policy-link": "Política de Cookies.",
   "invalid-email-address-validation": "Endereço de email inválido",
   "password-min-length-validation": "A palavra-passe deve ter pelo menos 8 caracteres",
   "password-complexity-validation": "A palavra-passe deve conter pelo menos uma letra maiúscula, um número e um dos símbolos especificados !, @, #, $, %, ^, &, *",
   "password-required-validation": "A palavra-passe é obrigatória",
   "passwords-must-match-validation": "As palavras-passe devem coincidir",
   "confirm-password-required-validation": "A confirmação da palavra-passe é obrigatória",
   "organization-name-required-validation": "O nome da Organização Internacional é obrigatório",
   "foundation-year-required-validation": "O ano de fundação é obrigatório",
   "sectors-min-validation": "Deve ser selecionado pelo menos um setor",
   "sectors-required-validation": "Os setores são obrigatórios",
   "organization-address-required-validation": "O endereço da organização é obrigatório",
   "invalid-organization-email-validation": "Email da organização inválido",
   "organization-email-required-validation": "O email da organização é obrigatório",
   "accept-terms-required-validation": "Deve aceitar os termos e condições",

   // Donor registration form
   "as-an-international-donor-label": "como Doador Internacional",
   "donor-organization-name-required-validation": "O nome da organização é obrigatório",
   "invitation-code-label": "Código de convite",
   "enter-invitation-code-placeholder": "Introduza o seu código de convite",
   "invitation-code-min-length-validation": "O código de convite deve ter pelo menos 12 caracteres",
   "invitation-code-required-validation": "O código de convite é obrigatório",
   "invalid-invitation-code-format-validation": "Formato de código de convite inválido",
   "no-invitation-code-help-text": "Se não tiver um código de convite, envie-nos um email para:",

   // Terms/Conditions modal
   "close-icon-alt": "Fechar",
   "terms-of-service-tab-label": "Termos de serviço",
   "privacy-policy-tab-label": "Política de privacidade",
   "cookie-policy-tab-label": "Política de cookies",
   "got-it-button": "Entendi!",

   // Shared auth thunk toasts (donor/expert registration)
   "account-created-success-description": "Conta criada com sucesso.",
   "unexpected-error-description": "Ocorreu um erro inesperado. Por favor, tente novamente.",
   "verification-code-sent-description": "Um código de verificação foi enviado para o seu email.",
   "expert-user-created-success-description": "Utilizador especialista criado com sucesso",

   // Expert registration step one
   "as-an-expert-label": "como Especialista",

   // Expert registration step three
   "lets-start-profile-info-title": "Vamos começar com as informações do seu perfil",
   "enter-full-name-placeholder": "Introduza o seu nome completo",
   "personal-statement-label": "Declaração pessoal/motivação",
   "enter-personal-statement-placeholder": "Introduza a sua declaração pessoal",
   "select-nationality-placeholder": "Selecione a sua nacionalidade",
   "select-country-of-residence-placeholder": "Selecione o seu país de residência",
   "operating-countries-label": "Países de operação",
   "enter-linkedin-profile-placeholder": "Introduza o seu perfil do LinkedIn",
   "full-name-required-validation": "O nome completo é obrigatório",
   "nationality-required-validation": "A nacionalidade é obrigatória",
   "country-of-residence-required-validation": "O país de residência é obrigatório",

   // Expert registration step four
   "now-your-professional-details-title": "Agora os seus dados profissionais",
   "profile-picture-label": "Foto de perfil",
   "education-section-title": "Formação académica",
   "select-highest-degree-placeholder": "Selecione o grau académico mais elevado obtido",
   "enter-fields-of-study-placeholder": "Introduza as áreas de estudo",
   "enter-educational-institution-placeholder": "Introduza a sua instituição de ensino",
   "area-label": "Área",
   "enter-area-placeholder": "Introduza a área",
   "add-another-area-button": "Adicionar outra área",
   "level-label": "Nível",
   "select-level-placeholder": "Selecionar nível",
   "add-another-language-button": "Adicionar outro idioma",
   "upload-cv-label": "Carregue o seu CV",
   "upload-certificate-label": "Carregue um certificado ou uma formação especial",
   "remove-button": "Remover",
   "image-file-type-badge": "JPG ou PNG",
   "pdf-file-type-badge": "PDF",
   "highest-degree-required-validation": "O grau académico mais elevado é obrigatório",
   "area-required-validation": "A área é obrigatória",
   "years-of-experience-required-validation": "Os anos de experiência são obrigatórios",
   "years-of-experience-number-validation": "Os anos de experiência devem ser um número",
   "profile-picture-required-validation": "A foto de perfil é obrigatória",
   "invalid-image-file-type-validation": "Tipo de ficheiro inválido. Apenas são permitidos PNG ou JPEG.",
   "file-size-too-large-validation": "O ficheiro é demasiado grande. O tamanho máximo é 20 MB.",
   "invalid-pdf-file-type-validation": "Tipo de ficheiro inválido. Apenas é permitido PDF.",
   "level-required-validation": "O nível é obrigatório",
   "level-number-validation": "O nível deve ser um número",
   "go-back-to-profile-details-link": "Voltar aos detalhes do perfil",
   "uploaded-file-icon-alt": "Ficheiro",
   "add-icon-alt": "Adicionar",

   // Confirm-code page
   "verification-code-title": "Código de verificação",
   "verification-code-sent-to-text": "Introduza o código de verificação que enviámos para",
   "verify-code-button": "Verificar código",
   "didnt-receive-code-text": "Se não recebeu um código de verificação,",
   "resend-code-link": "clique aqui para o reenviar",
   "or-send-email-at-text": "ou envie-nos um email para",
   "verification-code-required-validation": "O código de verificação é obrigatório",
   "code-verified-success-description": "Código verificado com sucesso",

   // Account on review page
   "account-on-review-icon-alt": "Conta em análise",
   "got-your-application-title": "Recebemos a sua candidatura!",
   "application-review-description-text": "Receberá um email de confirmação assim que um administrador aprovar o seu pedido.",
   "in-the-meantime-prefix-text": "Entretanto, visite",
   "in-the-meantime-suffix-text": "para mais informações.",
   "thank-you-for-interest-text": "Obrigado pelo seu interesse na KAPorg!",

   // Resources library
   "resources-library-tab-label": "Biblioteca de recursos",
   "resource-type-all-label": "Todos os recursos",
   "resource-type-documents-label": "Documentos",
   "resource-type-videos-label": "Vídeos",
   "resource-type-links-label": "Links",
   "resource-type-presentations-label": "Apresentações",
   "no-resources-available-text": "Nenhum recurso disponível",
   "no-collections-available-text": "Nenhuma coleção disponível",
   "which-resource-looking-for-label": "O que está a procurar?",
   "search-ellipsis-placeholder": "Pesquisar...",
   "assessments-placeholder": "Avaliações",
   "modules-label": "Módulos",
   "section-label": "Secção",
   "sections-placeholder": "Secções",
   "resource-icon-alt": "Recursos",
   "copy-link-action": "Copiar link",
   "edit-resource-icon-alt": "Editar recurso",
   "rate-this-resource-action": "Avaliar este recurso",
   "delete-resource-icon-alt": "Eliminar recurso",
   "more-suffix-text": "mais",
   "rate-this-resource-title": "Avaliar este recurso",
   "resource-word": "Recurso",
   "your-rating-label": "A sua avaliação:",
   "save-rating-button": "Guardar avaliação",
   "all-tab-label": "Todas",
   "my-collections-label": "Coleções",
   "my-collection-toggle-label": "Minha coleção",
   "all-collections-label": "Coleções",
   "edit-collection-icon-alt": "Editar coleção",
   "delete-collection-icon-alt": "Eliminar coleção",
   "preview-colon-label": "Pré-visualização:",
   "resources-word": "Recursos",

   // Top navigation bar: account/user menu (PopoverLinks)
   "account-summary-icon-alt": "resumo da conta",
   "account-summary-label": "Resumo da conta",
   "account-summary-upgrade-message":
      "Está a atingir o limite do seu pacote. Faça um upgrade para ter mais espaço e criar sem limites.",
   "upgrade-package-button": "Atualizar pacote",
   "modules-available-label": "Módulos disponíveis",
   "modules-created-label": "Módulos criados",
   "assessments-available-label": "Avaliações disponíveis",
   "assessments-created-label": "Avaliações criadas",
   "workspaces-available-label": "Espaços de trabalho disponíveis",
   "workspaces-created-label": "Espaços de trabalho criados",
   "including-humanitarian-experts-created-label": "incluindo especialistas humanitários criados",
   "amount-of-storage-label": "Quantidade de armazenamento",
   "data-usage-label": "Uso de dados",
   "usage-statistics-label": "Estatísticas de utilização",
   "available-label": "Disponível",
   "used-label": "Utilizado",
   "profile-info-icon-alt": "informações do perfil",
   "profile-information-label": "Informações do perfil",
   "login-info-icon-alt": "informações de início de sessão",
   "login-information-label": "Informações de início de sessão",
   "payment-info-icon-alt": "informações de pagamento",
   "payment-information-label": "Informações de pagamento",
   "log-out-icon-alt": "terminar sessão",
   "log-out-button": "Terminar sessão",
   "account-menu-toggle-alt": "Menu da conta",

   // Top navigation bar: mobile header
   "menu-toggle-icon-alt": "Menu",
   "logo-alt-text": "Logótipo",

   // Top navigation bar: notifications popover
   "mark-all-as-read-button": "Marcar tudo como lido",
   "unread-tab-label": "Não lidas",
   "no-notifications-title-text": "Não há notificações aqui!",
   "up-to-date-description-text": "Está tudo atualizado!",

   // Terms of Service (legal document body) - translated
   "terms-last-updated-text": "Estes Termos de Serviço foram atualizados pela última vez em 4 de março de 2024.",
   "terms-intro-websites-prefix-text": "Estes Termos de Serviço regem a utilização dos nossos websites disponíveis em",
   "terms-intro-websites-suffix-text": ", bem como quaisquer serviços relacionados prestados pela International Advisory, Products and Systems Ltd. Ao aceder aos nossos websites, concorda em cumprir estes Termos de Serviço e em respeitar todas as leis e regulamentos aplicáveis. Caso não concorde com estes Termos de Serviço, está impedido de utilizar ou aceder a esses websites ou de utilizar quaisquer outros serviços prestados pela International Advisory, Products and Systems Ltd. Nós, a International Advisory, Products and Systems Ltd, reservamo-nos o direito de rever e alterar quaisquer destes Termos de Serviço a nosso exclusivo critério. Ao fazê-lo, atualizaremos esta página. Quaisquer alterações a estes Termos de Serviço entrarão em vigor imediatamente a partir da data de publicação.",
   "overview-of-services-title": "Visão Geral dos Serviços",
   "overview-of-services-description-text": "A International Advisory, Products and Systems Ltd. (i-APS), em conjunto com as suas entidades afiliadas, incluindo, entre outras, a KAPsurvey, a KAPorg, a KAPinsights e a KAPcourse (doravante designadas coletivamente por \"KAPtech Group\"), presta serviços de consultoria técnica, soluções tecnológicas inovadoras e ferramentas abrangentes de recolha e análise de dados. As ofertas da KAPtech Group destinam-se a apoiar a execução e a gestão de projetos especializados e de desenvolvimento. Estes serviços utilizam tecnologia de ponta e tiram partido de um vasto conhecimento especializado local para ajudar as organizações parceiras e as comunidades a responder eficazmente e a superar desafios nos setores da ajuda especializada e do desenvolvimento. Ao utilizar os serviços prestados pela KAPtech Group, incluindo o acesso aos nossos websites, concorda em cumprir e ficar vinculado aos termos e condições estabelecidos neste acordo. Os serviços oferecidos estão sujeitos aos termos aqui descritos, bem como a quaisquer orientações ou regras adicionais aplicáveis a serviços ou funcionalidades específicos dos serviços.",
   "limitations-of-use-title": "Limitações de Utilização",
   "limitations-of-use-intro-text": "Ao utilizar os nossos websites, garante, em seu nome, em nome dos seus utilizadores e de outras partes que representa, que não irá:",
   "limitation-modify-content-text": "modificar, copiar, preparar obras derivadas, descompilar ou realizar engenharia inversa de quaisquer materiais e software contidos nesses websites;",
   "limitation-remove-notices-text": "remover quaisquer avisos de direitos de autor ou outras notações de propriedade de quaisquer materiais e software presentes nesses websites;",
   "limitation-transfer-materials-text": "transferir os materiais para outra pessoa ou \"espelhar\" os materiais em qualquer outro servidor;",
   "limitation-abuse-networks-text": "utilizar, de forma consciente ou negligente, esses websites ou quaisquer dos seus serviços associados de um modo que abuse ou perturbe as nossas redes ou qualquer outro serviço prestado pela International Advisory, Products and Systems Ltd;",
   "limitation-unlawful-material-text": "utilizar esses websites ou os seus serviços associados para transmitir ou publicar qualquer material assediador, indecente, obsceno, fraudulento ou ilícito;",
   "limitation-violate-laws-text": "utilizar esses websites ou os seus serviços associados em violação de quaisquer leis ou regulamentos aplicáveis;",
   "limitation-spam-text": "utilizar esses websites em conjunto com o envio de publicidade não autorizada ou spam;",
   "limitation-harvest-data-text": "captar, recolher ou reunir dados de utilizadores sem o consentimento do utilizador; ou",
   "limitation-infringe-rights-text": "utilizar esses websites ou os seus serviços associados de forma que possa infringir a privacidade, os direitos de propriedade intelectual ou outros direitos de terceiros",
   "intellectual-property-title": "Propriedade Intelectual",
   "intellectual-property-description-text": "A propriedade intelectual dos materiais contidos nesses websites pertence à International Advisory, Products and Systems Ltd ou está licenciada a esta, sendo protegida pela legislação aplicável em matéria de direitos de autor e marcas registadas. Concedemos aos nossos utilizadores permissão para descarregar uma cópia dos materiais para uso pessoal, não comercial e transitório. Isto constitui a concessão de uma licença, e não a transferência de titularidade. Esta licença cessará automaticamente se violar qualquer uma destas restrições ou os Termos de Serviço, e pode ser rescindida pela International Advisory, Products and Systems Ltd a qualquer momento.",
   "user-generated-content-title": "Conteúdo Gerado pelo Utilizador",
   "terms-user-generated-content-description-text": "Mantém os seus direitos de propriedade intelectual sobre o conteúdo que nos submete para publicação nos nossos websites. Nunca reivindicaremos a propriedade do seu conteúdo, mas necessitamos de uma licença sua para o poder utilizar. Ao utilizar os nossos websites ou os seus serviços associados para publicar, carregar, partilhar ou transmitir de outro modo conteúdo abrangido por direitos de propriedade intelectual, concede-nos uma licença não exclusiva, isenta de royalties, transferível, sublicenciável e válida a nível mundial para utilizar, distribuir, modificar, executar, copiar, exibir publicamente, traduzir ou, de outro modo, criar obras derivadas do seu conteúdo, de forma consistente com as suas preferências de privacidade e com a nossa Política de Privacidade. A licença que nos concede pode ser rescindida a qualquer momento mediante a eliminação do seu conteúdo ou conta. Contudo, na medida em que nós (ou os nossos parceiros) tenhamos utilizado o seu conteúdo em ligação com conteúdo comercial ou patrocinado, a licença manter-se-á em vigor até que a publicação comercial ou patrocinada em causa seja descontinuada por nós. Concede-nos permissão para utilizar o seu nome de utilizador e outras informações identificativas associadas à sua conta, de forma consistente com as suas preferências de privacidade e com a nossa Política de Privacidade.",
   "registration-and-payments-title": "Registo e Pagamentos",
   "registration-and-payments-description-text": "Para utilizar qualquer um dos nossos serviços, é necessário criar uma conta. Qualquer informação fornecida deve ser exata e atualizada sempre que necessário. Os clientes são responsáveis pela manutenção das suas contas e assumem total responsabilidade por todas as atividades que ocorram no âmbito das mesmas. Caso alguém obtenha acesso não autorizado à sua conta, deve notificar-nos de imediato. A International Advisory, Products and Systems Ltd não é responsável por qualquer perda ou dano resultante da falta de confidencialidade da sua conta. Ao criar a sua conta, é-lhe exigido que forneça as informações financeiras relevantes para o método de pagamento escolhido. Em alguns casos, poderá ser-lhe solicitado que forneça os dados do seu cartão de crédito. Note-se que quaisquer pagamentos efetuados na nossa plataforma serão processados pela PayPal, Stripe, Square, Google Payments ou Apple Pay. Como tal, não seremos responsáveis pelo processamento ou pela conservação de quaisquer das suas informações financeiras. A PayPal, a Stripe, a Square, a Google Payments ou a Apple Pay tratarão todas as suas informações financeiras de acordo com os respetivos Termos de Serviço, e o utilizador concorda em cumprir esses Termos de Serviço.",
   "disclaimer-and-limitations-title": "Isenção de Responsabilidade e Limitações de Responsabilidade",
   "disclaimer-websites-prefix-text": "Os websites e materiais disponibilizados pela International Advisory, Products and Systems Ltd., incluindo, entre outros,",
   "disclaimer-as-is-description-text": ", são disponibilizados aos utilizadores \"tal como se encontram\" (\"as is\"). A International Advisory, Products and Systems Ltd exclui todas as garantias, expressas ou implícitas, na medida permitida por lei. Isto inclui, entre outras, as garantias de comercialização, adequação a um fim específico ou não violação de direitos de propriedade intelectual. Além disso, nenhum conselho ou informação, oral ou escrita, obtida por si junto da International Advisory, Products and Systems Ltd ou através dos serviços, criará qualquer garantia não expressamente enunciada nestes termos. A International Advisory, Products and Systems Ltd e os seus fornecedores não serão responsáveis por quaisquer danos diretos, indiretos, incidentais, especiais, consequenciais ou exemplares, incluindo, entre outros, danos por perda de lucros, de goodwill, de utilização, de dados ou outras perdas intangíveis (mesmo que a International Advisory, Products and Systems Ltd tenha sido avisada da possibilidade de tais danos), resultantes da utilização ou da impossibilidade de utilizar os serviços ou de qualquer outra questão relacionada com os serviços. Esta limitação de responsabilidade aplica-se independentemente de a alegada responsabilidade se basear em contrato, responsabilidade civil extracontratual, negligência, responsabilidade objetiva ou qualquer outro fundamento, mesmo que a International Advisory, Products and Systems Ltd tenha sido avisada da possibilidade de tais danos. Dada a natureza dos serviços prestados pela International Advisory, Products and Systems Ltd, especialmente no contexto dos setores especializados e de desenvolvimento, os utilizadores reconhecem os riscos inerentes envolvidos na recolha de dados e na utilização de soluções baseadas em tecnologia. Os utilizadores são os únicos responsáveis por assegurar o cumprimento de todas as leis e regulamentos aplicáveis, incluindo, entre outros, as leis de proteção de dados e de privacidade. A responsabilidade por obter os consentimentos e autorizações necessários para a recolha de dados, particularmente quando envolvam menores ou dados sensíveis, cabe ao utilizador. A responsabilidade da International Advisory, Products and Systems Ltd e das suas afiliadas, administradores, diretores, colaboradores, agentes, fornecedores e licenciadores está limitada na medida máxima permitida por lei. Se não estiver satisfeito com qualquer parte dos serviços, ou com qualquer um destes termos, o seu único e exclusivo recurso consiste em deixar de utilizar os serviços. Algumas jurisdições não permitem a exclusão de determinadas garantias ou a limitação ou exclusão de responsabilidade por danos incidentais ou consequenciais, pelo que algumas das limitações acima referidas podem não se aplicar ao seu caso.",
   "accuracy-of-materials-title": "Exatidão dos Materiais",
   "accuracy-of-materials-description-text": "Os materiais disponibilizados nos nossos websites não são exaustivos e destinam-se apenas a fins de informação geral. A International Advisory, Products and Systems Ltd não garante nem faz quaisquer declarações relativamente à exatidão, aos resultados prováveis ou à fiabilidade da utilização dos materiais nesses websites, nem quanto a tais materiais ou a quaisquer recursos ligados a esses websites. Não deve basear-se exclusivamente nos referidos materiais para tomar decisões, recomendando-se que consulte outras fontes de informação mais completas. É o único responsável por confiar estritamente nos materiais publicados nos nossos websites. Reservamo-nos o direito de alterar a informação constante dos nossos websites sem aviso prévio, cabendo aos utilizadores a responsabilidade de acompanhar essas alterações.",
   "additional-tools-title": "Ferramentas Adicionais",
   "additional-tools-description-text": "Note-se que os nossos websites podem incluir ferramentas de terceiros que estão fora do nosso controlo. O acesso a essas ferramentas é disponibilizado \"tal como se encontra\" (\"as is\"), sem quaisquer garantias, expressas ou implícitas, e sem qualquer aprovação. Não somos responsáveis pela utilização das ferramentas de terceiros disponibilizadas nos nossos websites. É o único responsável por quaisquer riscos associados à utilização dessas ferramentas, recomendando-se a leitura dos Termos de Serviço do respetivo fornecedor terceiro. A International Advisory, Products and Systems Ltd tem o direito de oferecer novas ferramentas de terceiros no futuro",
   "links-title": "Ligações",
   "links-description-text": "A International Advisory, Products and Systems Ltd não analisou todos os sites associados aos seus websites através de ligações e não é responsável pelo conteúdo de qualquer um desses sites associados. A inclusão de qualquer ligação não implica aprovação, endosso ou controlo do site por parte da International Advisory, Products and Systems Ltd. A utilização de qualquer site associado é feita por sua conta e risco, pelo que recomendamos vivamente que efetue as suas próprias averiguações quanto à adequação desses sites.",
   "inaccuracies-and-mistakes-title": "Inexatidões e Erros",
   "inaccuracies-and-mistakes-description-text": "Note-se que qualquer conteúdo disponível nos nossos websites pode conter erros tipográficos, inexatidões ou erros relacionados com a descrição, o preço, a promoção e a disponibilidade do serviço. Reservamo-nos o direito de cancelar ou atualizar quaisquer serviços existentes caso se comprove que alguma informação por nós fornecida é inexata. Essa informação pode ser alterada a qualquer momento, sem aviso prévio. Note-se que não estamos obrigados a esclarecer qualquer informação relacionada com os nossos websites e serviços, incluindo informações sobre preços, exceto quando tal seja exigido por lei.",
   "indemnification-title": "Indemnização",
   "indemnification-description-text": "Concorda em defender, indemnizar e isentar-nos de responsabilidade, incluindo as nossas subsidiárias, afiliadas e todos os respetivos diretores, agentes, sócios e colaboradores, relativamente a qualquer perda, dano, responsabilidade, reclamação ou exigência, incluindo honorários e despesas de advogados razoáveis, apresentados por qualquer terceiro em virtude de, ou decorrentes de: (1) as suas Contribuições; (2) a utilização dos websites; (3) a violação destes Termos de Serviço; (4) qualquer violação das suas declarações e garantias estabelecidas nestes Termos de Serviço; (5) a violação, por sua parte, dos direitos de terceiros, incluindo, entre outros, direitos de propriedade intelectual; ou (6) qualquer ato manifestamente prejudicial praticado contra qualquer outro utilizador dos websites com quem tenha estabelecido contacto através dos websites.",
   "indemnification-defense-text": "Não obstante o acima exposto, reservamo-nos o direito, a expensas suas, de assumir a defesa exclusiva e o controlo de qualquer questão relativamente à qual seja obrigado a indemnizar-nos, e o utilizador concorda em cooperar, a expensas suas, com a nossa defesa relativamente a tais reclamações. Envidaremos esforços razoáveis para o notificar de qualquer reclamação, ação ou processo sujeito a esta indemnização, assim que dele tomarmos conhecimento.",
   "right-to-terminate-title": "Direito de Rescisão",
   "right-to-terminate-description-text": "Podemos suspender ou rescindir o seu direito de utilizar os nossos websites e rescindir estes Termos de Serviço com efeitos imediatos, mediante notificação por escrito, em caso de qualquer violação destes Termos de Serviço.",
   "severance-title": "Separabilidade",
   "severance-description-text": "Qualquer cláusula destes Termos de Serviço que seja total ou parcialmente nula ou inexequível será separada na medida em que seja nula ou inexequível. A validade das restantes disposições destes Termos de Serviço não é afetada.",
   "entire-agreement-title": "Acordo Integral",
   "entire-agreement-description-text": "Estes Termos de Serviço e quaisquer políticas ou regras de funcionamento publicadas por nós nos websites, ou relativamente aos websites, constituem o acordo integral e o entendimento entre o utilizador e nós. O facto de não exercermos ou fazermos cumprir qualquer direito ou disposição destes Termos de Serviço não constituirá uma renúncia a esse direito ou disposição. Estes Termos de Serviço vigoram na medida máxima permitida por lei. Podemos ceder, a qualquer momento, a totalidade ou parte dos nossos direitos e obrigações a terceiros. Não seremos responsáveis por qualquer perda, dano, atraso ou falha de atuação causados por qualquer causa que esteja fora do nosso controlo razoável. Caso qualquer disposição ou parte de uma disposição destes Termos de Serviço seja considerada ilícita, nula ou inexequível, essa disposição ou parte da disposição será considerada separável destes Termos de Serviço, não afetando a validade e a exequibilidade das restantes disposições. Não se estabelece qualquer relação de joint venture, parceria, emprego ou agência entre o utilizador e nós em resultado destes Termos de Serviço ou da utilização dos websites. O utilizador concorda que estes Termos de Serviço não serão interpretados contra nós pelo facto de os termos terem sido por nós redigidos. Pelo presente, o utilizador renuncia a quaisquer defesas que possa ter com base na forma eletrónica destes Termos de Serviço e na ausência de assinatura das partes para a sua celebração.",
   "governing-law-title": "Lei Aplicável",
   "governing-law-description-text": "Estes Termos de Serviço são regidos e interpretados de acordo com as leis da Virginia. O utilizador submete-se irrevogavelmente à jurisdição exclusiva dos tribunais desse Estado ou localidade.",

   // Cookie Policy (legal document body)
   "cookie-last-updated-text": "Estes Termos de Serviço foram atualizados pela última vez em 4 de março de 2024.",
   "cookie-intro-websites-prefix-text": "Utilizamos cookies para ajudar a melhorar a sua experiência nos nossos websites em",
   "cookie-intro-websites-suffix-text": ". Esta política de cookies faz parte da política de privacidade da International Advisory, Products and Systems Ltd. Abrange a utilização de cookies entre o seu dispositivo e os nossos sites.",
   "cookie-third-party-services-notice-text": "Também fornecemos informações básicas sobre os serviços de terceiros que podemos utilizar, os quais também podem utilizar cookies como parte do seu serviço. Esta política não abrange os cookies desses terceiros.",
   "cookie-refuse-prefix-text": "Se não desejar aceitar os nossos cookies, deverá instruir o seu navegador para recusar cookies de",
   "cookie-refuse-suffix-text": ". Nesse caso, poderemos não conseguir fornecer-lhe alguns dos conteúdos e serviços pretendidos.",
   "what-is-a-cookie-title": "O que é um cookie?",
   "cookie-definition-text": "Um cookie é um pequeno fragmento de dados que um website armazena no seu dispositivo quando o visita. Normalmente, contém informações sobre o próprio website, um identificador único que permite ao site reconhecer o seu navegador quando regressa, dados adicionais que servem a finalidade do cookie, e o período de duração do próprio cookie.",
   "cookie-usage-examples-text": "Os cookies são utilizados para ativar determinadas funcionalidades (por exemplo, iniciar sessão), monitorizar a utilização do site (por exemplo, análises), armazenar as suas definições de utilizador (por exemplo, fuso horário, preferências de notificação) e personalizar o seu conteúdo (por exemplo, publicidade, idioma).",
   "first-party-cookies-definition-text": "Os cookies definidos pelo website que está a visitar são geralmente designados por cookies primários (first-party). Normalmente, apenas monitorizam a sua atividade nesse site específico.",
   "third-party-cookies-definition-text": "Os cookies definidos por outros sites e empresas (ou seja, terceiros) são designados por cookies de terceiros (third-party). Podem ser utilizados para o monitorizar noutros websites que utilizem o mesmo serviço de terceiros.",
   "cookie-types-title": "Tipos de cookies e forma como os utilizamos",
   "essential-cookies-definition-text": "Os cookies essenciais são fundamentais para a sua experiência num website, permitindo funcionalidades básicas como o início de sessão do utilizador, a gestão de contas, os carrinhos de compras e o processamento de pagamentos.",
   "essential-cookies-usage-text": "Utilizamos cookies essenciais para ativar determinadas funções nos nossos websites.",
   "performance-cookies-title": "Cookies de desempenho",
   "performance-cookies-definition-text": "Os cookies de desempenho monitorizam a forma como utiliza um website durante a sua visita. Normalmente, esta informação é anónima e agregada, sendo recolhida em relação a todos os utilizadores do site. Ajudam as empresas a compreender os padrões de utilização dos visitantes, a identificar e diagnosticar problemas ou erros que os seus utilizadores possam encontrar, e a tomar melhores decisões estratégicas para melhorar a experiência global do website para o seu público. Estes cookies podem ser definidos pelo website que está a visitar (primários/first-party) ou por serviços de terceiros. Não recolhem informações pessoais sobre si.",
   "performance-cookies-usage-text": "Utilizamos cookies de desempenho nos nossos sites.",
   "functionality-cookies-title": "Cookies de funcionalidade",
   "functionality-cookies-definition-text": "Os cookies de funcionalidade são utilizados para recolher informações sobre o seu dispositivo e quaisquer definições que possa configurar no website que está a visitar (como as definições de idioma e fuso horário). Com esta informação, os websites podem fornecer-lhe conteúdos e serviços personalizados, melhorados ou otimizados. Estes cookies podem ser definidos pelo website que está a visitar (primários/first-party) ou por serviços de terceiros.",
   "functionality-cookies-usage-text": "Utilizamos cookies de funcionalidade para determinadas funcionalidades nos nossos sites.",
   "targeting-advertising-cookies-title": "Cookies de segmentação/publicidade",
   "targeting-advertising-cookies-definition-text": "Os cookies de segmentação/publicidade ajudam a determinar que conteúdo promocional é mais relevante e adequado para si e para os seus interesses. Os websites podem utilizá-los para apresentar publicidade direcionada ou para limitar o número de vezes que vê um anúncio. Isto ajuda as empresas a melhorar a eficácia das suas campanhas e a qualidade do conteúdo que lhe é apresentado. Estes cookies podem ser definidos pelo website que está a visitar (primários/first-party) ou por serviços de terceiros. Os cookies de segmentação/publicidade definidos por terceiros podem ser utilizados para o monitorizar noutros websites que utilizem o mesmo serviço de terceiros.",
   "targeting-advertising-cookies-usage-text": "Utilizamos cookies de segmentação/publicidade nos nossos sites.",
   "control-cookies-title": "Como Pode Controlar a Utilização de Cookies pelo Nosso Website?",
   "cookie-consent-manager-description-text": "Tem o direito de decidir se aceita ou rejeita cookies nos nossos websites. Pode gerir as suas preferências de cookies no nosso Cookie Consent Manager. O Cookie Consent Manager permite-lhe selecionar quais as categorias de cookies que aceita ou rejeita. Os cookies essenciais não podem ser rejeitados, uma vez que são estritamente necessários para lhe fornecer os serviços disponíveis nos nossos websites.",
   "browser-settings-cookie-control-text": "Também poderá definir ou alterar as suas preferências de cookies através da gestão das definições do seu navegador. Uma vez que cada navegador é diferente, consulte as instruções fornecidas pelo seu navegador (normalmente na secção \"ajuda\"). Se optar por recusar ou desativar os cookies, ainda poderá utilizar os nossos websites, embora algumas das suas funcionalidades possam não estar disponíveis.",
   "cookie-policy-update-frequency-title": "Com Que Frequência Atualizaremos Esta Política de Cookies?",
   "cookie-policy-update-reason-text": "Poderemos atualizar esta Política de Cookies periodicamente, de forma a refletir quaisquer alterações aos cookies e tecnologias relacionadas que utilizamos, ou por outras razões operacionais, legais ou regulamentares.",
   "cookie-policy-version-notice-text": "Sempre que utilizar os nossos websites, aplicar-se-á a versão atual da Política de Cookies. Ao utilizar os nossos websites, deverá verificar a data desta Política de Cookies (que consta no início deste documento) e rever quaisquer alterações desde a última versão.",
   "cookie-policy-further-info-title": "Onde Pode Obter Mais Informações?",
   "cookie-policy-contact-us-description-text": "Para quaisquer questões ou preocupações relativas à nossa Política de Cookies, poderá contactar-nos através dos seguintes dados:",

   // Privacy Policy (legal document body)
   "privacy-last-updated-text": "Estes Termos de Serviço foram atualizados pela última vez em 4 de março de 2024.",
   "privacy-intro-websites-prefix-text": "A sua privacidade é importante para nós. É política da International Advisory, Products and Systems Ltd respeitar a sua privacidade e cumprir toda a legislação e regulamentação aplicável relativa a quaisquer informações pessoais que possamos recolher sobre si, incluindo através dos nossos sites,",
   "privacy-intro-websites-suffix-text": ", e outros sites que possuímos e operamos.",
   "personal-information-definition-text": "Informações pessoais são quaisquer informações sobre si que possam ser utilizadas para o identificar. Isto inclui informações sobre si enquanto pessoa (tais como nome, morada e data de nascimento), os seus dispositivos, dados de pagamento e até informações sobre a forma como utiliza um site ou serviço online.",
   "third-party-sites-disclaimer-text": "Caso os nossos sites contenham ligações para sites e serviços de terceiros, tenha em atenção que esses sites e serviços têm as suas próprias políticas de privacidade. Após seguir uma ligação para qualquer conteúdo de terceiros, deverá ler a informação sobre a política de privacidade publicada por esses terceiros relativa à forma como recolhem e utilizam informações pessoais. Esta Política de Privacidade não se aplica a quaisquer atividades suas após sair de um dos nossos sites.",
   "information-we-collect-title": "Informações que Recolhemos",
   "information-categories-intro-text": "As informações que recolhemos enquadram-se numa de duas categorias: informações \"voluntariamente fornecidas\" e informações \"recolhidas automaticamente\"",
   "voluntarily-provided-info-description-text": "As informações \"voluntariamente fornecidas\" referem-se a quaisquer informações que o utilizador forneça de forma consciente e ativa quando utiliza ou participa em qualquer um dos nossos serviços e promoções.",
   "automatically-collected-info-description-text": "As informações \"recolhidas automaticamente\" referem-se a quaisquer informações enviadas automaticamente pelos dispositivos do utilizador durante o acesso aos nossos produtos e serviços.",
   "log-data-title": "Dados de Registo",
   "log-data-description-text": "Quando o utilizador visita um dos nossos sítios Web, os nossos servidores podem registar automaticamente os dados-padrão fornecidos pelo seu navegador. Estes podem incluir o endereço de Protocolo de Internet (IP) do dispositivo do utilizador, o tipo e a versão do navegador, as páginas visitadas, a hora e a data da visita, o tempo despendido em cada página e outros detalhes sobre a sua visita.",
   "log-data-errors-description-text": "Adicionalmente, caso o utilizador encontre determinados erros ao utilizar os nossos sítios, podemos recolher automaticamente dados sobre o erro e as circunstâncias que rodearam a sua ocorrência. Estes dados podem incluir detalhes técnicos sobre o dispositivo do utilizador, o que este estava a tentar fazer no momento em que o erro ocorreu, e outras informações técnicas relacionadas com o problema. O utilizador poderá ou não receber notificação de tais erros, mesmo no momento em que ocorrem, de que ocorreram, ou qual a natureza do erro.",
   "log-data-combination-warning-text": "Tenha em atenção que, embora esta informação possa não ser, por si só, pessoalmente identificável, poderá ser possível combiná-la com outros dados para identificar pessoalmente pessoas individuais.",
   "device-data-title": "Dados do Dispositivo",
   "device-data-intro-text": "Quando visita os nossos sites ou interage com os nossos serviços, poderemos recolher automaticamente dados sobre o seu dispositivo, tais como:",
   "device-type-label": "Tipo de dispositivo",
   "operating-system-label": "Sistema operativo",
   "unique-device-identifiers-label": "Identificadores exclusivos do dispositivo",
   "geo-location-data-label": "Dados de geolocalização",
   "device-data-settings-note-text": "Os dados que recolhemos podem depender das definições individuais do seu dispositivo e software. Recomendamos que consulte as políticas do fabricante do seu dispositivo ou do fornecedor do software para saber que informações disponibilizam.",
   "personal-information-title": "Informações Pessoais",
   "personal-information-intro-text": "Podemos solicitar informações pessoais — por exemplo, quando subscreve a nossa newsletter ou quando nos contacta — que podem incluir um ou mais dos seguintes elementos:",
   "social-media-profiles-label": "Perfis de redes sociais",
   "date-of-birth-label": "Data de nascimento",
   "phone-mobile-number-label": "Número de telefone/telemóvel",
   "home-mailing-address-label": "Morada de residência/correspondência",
   "work-related-information-label": "Informações relacionadas com o trabalho",
   "company-name-label": "Nome da empresa",
   "title-field-label": "Cargo",
   "sensitive-information-title": "Informação Sensível",
   "sensitive-information-definition-text": "\\\"Informação sensível\\\" ou \\\"categorias especiais de dados\\\" é um subconjunto de informação pessoal ao qual é atribuído um nível de proteção mais elevado. Exemplos de informação sensível incluem informação relativa à sua origem racial ou étnica, opiniões políticas, religião, filiação sindical ou outras associações ou filiações profissionais, convicções filosóficas, orientação sexual, práticas sexuais ou vida sexual, registos criminais, informação de saúde ou informação biométrica.",
   "sensitive-information-types-intro-text": "Os tipos de informação sensível que podemos recolher sobre si incluem:",
   "sensitive-information-consent-text": "Não recolheremos informação sensível sobre si sem primeiro obter o seu consentimento, e apenas utilizaremos ou divulgaremos a sua informação sensível conforme permitido, exigido ou autorizado por lei.",
   "privacy-user-generated-content-description-text": "Consideramos \\\"conteúdo gerado pelo utilizador\\\" os materiais (conteúdos de texto, imagem e/ou vídeo) fornecidos voluntariamente pelos nossos utilizadores para efeitos de publicação, processamento ou utilização na nossa plataforma. Todo o conteúdo gerado pelo utilizador está associado à conta ou ao endereço de correio eletrónico utilizado para submeter os materiais.",
   "user-generated-content-publication-notice-text": "Tenha em atenção que qualquer conteúdo submetido para efeitos de publicação será público após a publicação (e o subsequente processo de revisão ou verificação). Uma vez publicado, poderá estar acessível a terceiros não abrangidos pela presente política de privacidade.",
   "transaction-data-title": "Dados de Transação",
   "transaction-data-description-text": "Os dados de transação referem-se aos dados que se acumulam ao longo do funcionamento normal da nossa plataforma. Estes podem incluir registos de transações, ficheiros armazenados, perfis de utilizador, dados analíticos e outras métricas, bem como outros tipos de informação criados ou gerados à medida que os utilizadores interagem com os nossos serviços.",
   "legitimate-reasons-title": "Motivos Legítimos para o Tratamento das Suas Informações Pessoais",
   "legitimate-reasons-description-text": "Apenas recolhemos e utilizamos as suas informações pessoais quando temos um motivo legítimo para o fazer. Nesse caso, recolhemos apenas as informações pessoais que sejam razoavelmente necessárias para lhe prestar os nossos serviços.",
   "collection-and-use-title": "Recolha e Utilização de Informações",
   "collection-and-use-intro-text": "Poderemos recolher as suas informações pessoais quando realizar qualquer uma das seguintes ações nos nossos sítios Web:",
   "collect-register-account-text": "Registar uma conta",
   "collect-purchase-subscription-text": "Adquirir uma subscrição",
   "collect-signup-updates-text": "Subscrever para receber as nossas atualizações por correio eletrónico ou por redes sociais",
   "collect-mobile-browser-text": "Utilizar um dispositivo móvel ou um navegador web para aceder ao nosso conteúdo",
   "collect-contact-us-text": "Contactar-nos por correio eletrónico, por redes sociais ou através de quaisquer tecnologias semelhantes",
   "collect-social-media-mention-text": "Quando nos menciona nas redes sociais",
   "collection-purposes-intro-text": "Podemos recolher, conservar, utilizar e divulgar informações para os seguintes fins, não sendo as informações pessoais posteriormente tratadas de forma incompatível com estes fins:",
   "purpose-core-features-text": "para lhe fornecer as funcionalidades e serviços essenciais da nossa plataforma",
   "purpose-customize-experience-text": "para lhe permitir personalizar ou adaptar a sua experiência nos nossos sítios Web",
   "purpose-deliver-products-text": "para lhe fornecer produtos e/ou serviços",
   "purpose-contact-communicate-text": "para lhe contactar e comunicar",
   "purpose-analytics-research-text": "para fins de análise, estudos de mercado e desenvolvimento de negócio, incluindo para operar e melhorar os nossos sítios Web, as aplicações associadas e as plataformas de redes sociais associadas",
   "purpose-advertising-marketing-text": "para fins de publicidade e marketing, incluindo o envio de informações promocionais sobre os nossos produtos e serviços e de informações sobre terceiros que consideremos poderem ser do seu interesse",
   "purpose-enable-access-text": "para lhe permitir aceder e utilizar os nossos sítios web, as aplicações associadas e as plataformas de redes sociais associadas",
   "purpose-record-keeping-text": "para efeitos de registo interno e fins administrativos",
   "purpose-legal-compliance-text": "para cumprir as nossas obrigações legais e resolver quaisquer litígios que possamos ter",
   "purpose-attribute-content-text": "para atribuir a autoria de qualquer conteúdo (por exemplo, publicações e comentários) que submeta e que publiquemos nos nossos sítios web",
   "purpose-security-fraud-text": "para fins de segurança e prevenção de fraude, e para garantir que os nossos sítios e aplicações são seguros, protegidos e utilizados em conformidade com os nossos termos de utilização",
   "purpose-technical-assessment-text": "para avaliação técnica, incluindo para operar e melhorar a nossa aplicação, as aplicações associadas e as plataformas de redes sociais associadas",
   "collection-combine-sources-text": "Podemos combinar as informações pessoais fornecidas voluntariamente e recolhidas automaticamente com informações gerais ou dados de investigação que recebamos de outras fontes fidedignas. Por exemplo, se nos fornecer a sua localização, poderemos combinar essa informação com informações gerais sobre moeda e idioma, a fim de lhe proporcionar uma experiência melhorada dos nossos sítios e serviço.",
   "security-of-information-title": "Segurança das Suas Informações Pessoais",
   "security-measures-description-text": "Quando recolhemos e tratamos informações pessoais, e enquanto conservarmos essas informações, iremos protegê-las através de meios comercialmente aceitáveis, de modo a prevenir a perda e o furto, bem como o acesso, a divulgação, a cópia, a utilização ou a modificação não autorizados.",
   "security-no-guarantee-text": "Embora façamos os possíveis para proteger as informações pessoais que nos fornece, informamos que nenhum método de transmissão ou armazenamento eletrónico é 100% seguro e que ninguém pode garantir a segurança absoluta dos dados.",
   "security-password-responsibility-text": "É da sua responsabilidade a escolha de qualquer palavra-passe e o respetivo nível geral de segurança, assegurando a segurança das suas próprias informações dentro dos limites dos nossos serviços. Por exemplo, garantir que quaisquer palavras-passe associadas ao acesso às suas informações pessoais e contas são seguras e confidenciais.",
   "retention-period-title": "Durante Quanto Tempo Conservamos as Suas Informações Pessoais",
   "retention-period-description-text": "Apenas conservamos as suas informações pessoais durante o período de tempo necessário. Este período pode depender da finalidade para a qual utilizamos as suas informações, em conformidade com esta política de privacidade. Por exemplo, se nos tiver fornecido informações pessoais no âmbito da criação de uma conta connosco, poderemos conservar essas informações durante o período em que a sua conta existir no nosso sistema. Se as suas informações pessoais deixarem de ser necessárias para esta finalidade, iremos eliminá-las ou torná-las anónimas, removendo todos os detalhes que o identifiquem.",
   "retention-legal-obligation-text": "No entanto, se necessário, poderemos conservar as suas informações pessoais para cumprimento de uma obrigação legal, contabilística ou de reporte, ou para fins de arquivo de interesse público, para fins de investigação científica ou histórica, ou para fins estatísticos.",
   "childrens-privacy-title": "Privacidade das Crianças",
   "childrens-privacy-description-text": "Nenhum dos nossos produtos ou serviços se destina diretamente a crianças com idade inferior a 13 anos e não recolhemos, de forma consciente, informações pessoais sobre crianças com idade inferior a 13 anos.",
   "disclosure-to-third-parties-title": "Divulgação de Informações Pessoais a Terceiros",
   "disclosure-intro-text": "Podemos divulgar informações pessoais a:",
   "disclose-affiliate-text": "uma empresa-mãe, subsidiária ou afiliada da nossa empresa",
   "disclose-service-providers-text": "prestadores de serviços terceiros, com a finalidade de lhes permitir prestar os respetivos serviços, incluindo (sem limitação) prestadores de serviços de TI, fornecedores de armazenamento de dados, de alojamento (hosting) e de servidores, redes de publicidade, serviços de análise (analytics), registadores de erros, agências de cobrança de dívidas, prestadores de manutenção ou resolução de problemas, prestadores de marketing ou publicidade, consultores profissionais, e operadores de sistemas de pagamento",
   "disclose-employees-text": "os nossos colaboradores, contratados e/ou entidades relacionadas",
   "disclose-business-partners-text": "os nossos agentes ou parceiros de negócio, existentes ou potenciais",
   "disclose-credit-agencies-text": "agências de informação de crédito, tribunais e autoridades reguladoras, caso não efetue o pagamento de bens ou serviços que lhe tenham sido fornecidos por nós",
   "disclose-law-enforcement-text": "tribunais, órgãos jurisdicionais especializados, autoridades regulatórias e agentes de aplicação da lei, conforme exigido por lei, em relação a quaisquer processos judiciais reais ou potenciais, ou a fim de estabelecer, exercer ou defender os nossos direitos legais",
   "disclose-agents-subcontractors-text": "terceiros, incluindo agentes ou subcontratados que nos auxiliam na prestação de informações, produtos, serviços ou marketing direto ao utilizador",
   "disclose-collect-process-text": "terceiros para recolher e processar dados",
   "disclose-business-transfer-text": "uma entidade que compre, ou para a qual transfiramos, a totalidade ou a maior parte dos nossos ativos e negócio",
   "third-parties-currently-used-text": "Os terceiros que atualmente utilizamos incluem:",
   "international-transfers-title": "Transferências Internacionais de Dados Pessoais",
   "international-transfers-description-text": "As informações pessoais que recolhemos são armazenadas e/ou processadas nos Estados Unidos, ou onde nós ou os nossos parceiros, afiliados e fornecedores terceiros mantenham instalações.",
   "international-transfers-legal-note-text": "Os países para os quais armazenamos, processamos ou transferimos as suas informações pessoais podem não ter as mesmas leis de proteção de dados do país em que forneceu inicialmente as informações. Se transferirmos as suas informações pessoais para terceiros noutros países: (i) efetuaremos essas transferências em conformidade com os requisitos da lei aplicável; e (ii) protegeremos as informações pessoais transferidas em conformidade com a presente política de privacidade.",
   "your-rights-title": "Os Seus Direitos e o Controlo das Suas Informações Pessoais",
   "your-choice-description-text": "A sua escolha: Ao fornecer-nos informações pessoais, o titular compreende que iremos recolher, conservar, utilizar e divulgar as suas informações pessoais em conformidade com a presente política de privacidade. Não é obrigado a fornecer-nos informações pessoais; contudo, caso não o faça, tal poderá afetar a sua utilização dos nossos sítios web ou dos produtos e/ou serviços oferecidos neles ou através deles.",
   "info-from-third-parties-text": "Informações provenientes de terceiros: Se recebermos informações pessoais sobre si de um terceiro, iremos protegê-las conforme estabelecido na presente política de privacidade. Se for um terceiro que fornece informações pessoais sobre outra pessoa, declara e garante que possui o consentimento dessa pessoa para nos fornecer as respetivas informações pessoais",
   "marketing-permission-text": "Autorização de marketing: Se anteriormente concordou que utilizássemos as suas informações pessoais para fins de marketing direto, pode mudar de ideias a qualquer momento, contactando-nos através dos dados indicados abaixo.",
   "access-rights-text": "Acesso: Poderá solicitar informações pormenorizadas sobre os dados pessoais que detemos a seu respeito",
   "correction-rights-text": "Correção: Se considerar que qualquer informação que detemos a seu respeito é inexata, desatualizada, incompleta, irrelevante ou enganosa, contacte-nos através dos dados de contacto fornecidos nesta política de privacidade. Tomaremos as medidas razoáveis para corrigir qualquer informação considerada inexata, incompleta, enganosa ou desatualizada.",
   "non-discrimination-text": "Não discriminação: Não o(a) discriminaremos pelo exercício de quaisquer dos seus direitos relativamente aos seus dados pessoais. Salvo se os seus dados pessoais forem necessários para lhe prestar um determinado serviço ou oferta (por exemplo, o processamento de dados de transações), não lhe recusaremos bens ou serviços e/ou não lhe cobraremos preços ou tarifas diferentes por bens ou serviços, incluindo através da concessão de descontos ou outros benefícios, ou da imposição de penalizações, nem lhe forneceremos um nível ou qualidade diferente de bens ou serviços.",
   "download-personal-info-text": "Descarregamento de dados pessoais: Disponibilizamos um meio para descarregar os dados pessoais que partilhou através dos nossos sites. Contacte-nos para mais informações.",
   "data-breach-notification-text": "Notificação de violações de dados: Cumpriremos as leis aplicáveis relativamente a qualquer violação de dados.",
   "complaints-rights-text": "Reclamações: Se considerar que violámos uma lei de proteção de dados aplicável e pretender apresentar uma reclamação, contacte-nos através dos dados abaixo indicados e forneça-nos todos os pormenores da alegada violação. Investigaremos prontamente a sua reclamação e responder-lhe-emos, por escrito, indicando o resultado da nossa investigação e as medidas que tomaremos para tratar da sua reclamação. Tem também o direito de contactar um organismo regulador ou uma autoridade de proteção de dados relativamente à sua reclamação.",
   "unsubscribe-rights-text": "Cancelamento da subscrição: Para cancelar a subscrição da nossa base de dados de e-mail ou optar por não receber comunicações (incluindo comunicações de marketing), contacte-nos utilizando os dados fornecidos nesta política de privacidade, ou opte por não as receber utilizando as funcionalidades de exclusão disponibilizadas na comunicação. Poderá ser necessário solicitar-lhe informações específicas para nos ajudar a confirmar a sua identidade.",
   "use-of-cookies-title": "Utilização de Cookies",
   "use-of-cookies-description-text": "Utilizamos \"cookies\" para recolher informações sobre si e sobre a sua atividade nos nossos sites. Um cookie é um pequeno conjunto de dados que os nossos sites armazenam no seu computador e ao qual acedem cada vez que nos visita, para que possamos compreender como utiliza os nossos sites. Isto ajuda-nos a fornecer-lhe conteúdos com base nas preferências que especificou.",
   "refer-to-cookie-policy-text": "Para mais informações, consulte a nossa Política de Cookies.",
   "business-transfers-title": "Transferências Comerciais",
   "business-transfers-description-text": "Se nós ou os nossos ativos formos adquiridos, ou na eventualidade improvável de encerrarmos a atividade ou entrarmos em processo de insolvência, incluiríamos os dados, incluindo os seus dados pessoais, entre os ativos transferidos para quaisquer partes que nos adquiram. O utilizador reconhece que tais transferências podem ocorrer e que quaisquer partes que nos adquiram poderão, na medida permitida pela lei aplicável, continuar a utilizar os seus dados pessoais de acordo com esta política, a qual serão obrigadas a assumir, uma vez que constitui a base de quaisquer direitos de propriedade ou de utilização que detemos sobre tais informações.",
   "limits-of-policy-title": "Limites da Nossa Política",
   "limits-of-policy-description-text": "Os nossos sítios web podem conter ligações para sítios externos que não são operados por nós. Tenha em atenção que não temos qualquer controlo sobre o conteúdo e as políticas desses sítios, e não podemos aceitar qualquer responsabilidade ou ser responsabilizados pelas respetivas práticas de privacidade.",
   "changes-to-policy-title": "Alterações a Esta Política",
   "changes-to-policy-description-text": "A nosso critério, podemos alterar a nossa política de privacidade de forma a refletir atualizações aos nossos processos empresariais, às práticas atualmente aceites, ou alterações legislativas ou regulamentares. Se decidirmos alterar esta política de privacidade, publicaremos as alterações aqui, no mesmo link através do qual está a aceder a esta política de privacidade.",
   "changes-significant-notice-text": "Se as alterações forem significativas, ou se tal for exigido pela lei aplicável, iremos contactá-lo (com base nas preferências que selecionou para as comunicações da nossa parte) e a todos os nossos utilizadores registados, com os novos detalhes e as ligações para a política atualizada ou alterada.",
   "changes-permission-text": "Se exigido por lei, iremos obter a sua autorização ou dar-lhe a oportunidade de optar por aderir a ou renunciar a quaisquer novas utilizações das suas informações pessoais, consoante aplicável.",
   "au-privacy-act-title": "Divulgações Adicionais para Conformidade com a Lei de Privacidade Australiana (AU)",
   "au-privacy-act-description-text": "Nos casos em que a divulgação das suas informações pessoais esteja sujeita exclusivamente à legislação australiana em matéria de privacidade, o utilizador reconhece que alguns terceiros podem não estar regulados pela Privacy Act nem pelos Australian Privacy Principles previstos na Privacy Act. O utilizador reconhece que, caso algum desses terceiros pratique qualquer ato ou conduta que viole os Australian Privacy Principles, esse terceiro não seria responsabilizado ao abrigo da Privacy Act, e o utilizador não poderá obter reparação ao abrigo da Privacy Act.",
   "gdpr-compliance-title": "Divulgações Adicionais para Conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD) (UE)",
   "data-controller-processor-title": "Responsável pelo Tratamento / Subcontratante",
   "data-controller-processor-description-text": "O RGPD distingue entre organizações que tratam informações pessoais para os seus próprios fins (designadas «responsáveis pelo tratamento») e organizações que tratam informações pessoais em nome de outras organizações (designadas «subcontratantes»). Nós, International Advisory, Products and Systems Ltd, com sede na morada indicada na nossa secção de Contactos, somos Responsável pelo Tratamento e/ou Subcontratante no que respeita às informações pessoais que nos fornece.",
   "legal-bases-title": "Bases Jurídicas para o Tratamento das Suas Informações Pessoais",
   "legal-bases-description-text": "Apenas recolheremos e utilizaremos as suas informações pessoais quando tivermos o direito legal para o fazer. Nesse caso, recolheremos e utilizaremos as suas informações pessoais de forma lícita, leal e transparente. Se solicitarmos o seu consentimento para tratar as suas informações pessoais e tiver menos de 16 anos de idade, solicitaremos o consentimento do seu progenitor ou tutor legal para tratar as suas informações pessoais para essa finalidade específica.",
   "legal-bases-grounds-text": "As nossas bases legais dependem dos serviços que utiliza e da forma como os utiliza. Isto significa que apenas recolhemos e utilizamos as suas informações com base nos seguintes fundamentos:",
   "consent-from-you-title": "O Seu Consentimento",
   "consent-from-you-description-text": "Quando nos dá o seu consentimento para recolher e utilizar as suas informações pessoais para uma finalidade específica. Pode retirar o seu consentimento a qualquer momento, utilizando os meios que disponibilizamos; contudo, tal não afetará qualquer utilização das suas informações que já tenha ocorrido. Pode consentir em fornecer o seu endereço de correio eletrónico para efeitos de receção de mensagens de marketing da nossa parte. Embora possa cancelar a subscrição a qualquer momento, não podemos recuperar quaisquer mensagens de correio eletrónico que já tenhamos enviado. Se tiver quaisquer questões adicionais sobre como retirar o seu consentimento, sinta-se à vontade para nos contactar através dos dados fornecidos na secção \\\"Contacte-nos\\\" desta política de privacidade",
   "performance-of-contract-title": "Execução de um Contrato ou Transação",
   "performance-of-contract-description-text": "Quando tiver celebrado connosco um contrato ou transação, ou a fim de tomar medidas preparatórias antes de celebrarmos um contrato ou transação consigo. Por exemplo, se adquirir um produto, serviço ou subscrição junto de nós, poderemos necessitar de utilizar as suas informações pessoais e de pagamento a fim de processar e entregar a sua encomenda.",
   "legitimate-interests-title": "Os Nossos Interesses Legítimos",
   "legitimate-interests-description-text": "Quando consideramos que é necessário para os nossos interesses legítimos, tais como para fornecermos, operarmos, melhorarmos e comunicarmos os nossos serviços. Consideramos que os nossos interesses legítimos incluem a investigação e o desenvolvimento, a compreensão do nosso público, o marketing e a promoção dos nossos serviços, as medidas tomadas para operar os nossos serviços de forma eficiente, a análise de marketing, e as medidas tomadas para proteger os nossos direitos e interesses legais.",
   "compliance-with-law-title": "Cumprimento da Lei",
   "compliance-with-law-description-text": "Em alguns casos, podemos ter uma obrigação legal de utilizar ou conservar as suas informações pessoais. Tais casos podem incluir (mas não se limitam a) ordens judiciais, investigações criminais, pedidos governamentais e obrigações regulamentares. Se tiver quaisquer outras questões sobre a forma como conservamos as informações pessoais de modo a cumprir a lei, sinta-se à vontade para nos contactar através dos dados fornecidos na secção Contacte-nos desta política de privacidade.",
   "eea-transfers-title": "Transferências Internacionais para Fora do Espaço Económico Europeu (EEE)",
   "eea-transfers-description-text": "Iremos assegurar que qualquer transferência de informações pessoais de países do Espaço Económico Europeu (EEE) para países fora do EEE será protegida por salvaguardas adequadas, por exemplo através da utilização de cláusulas-tipo de proteção de dados aprovadas pela Comissão Europeia, ou da utilização de normas corporativas vinculativas ou de outros meios legalmente aceites.",
   "restrict-processing-rights-text": "Restringir: Tem o direito de solicitar que restrinjamos o tratamento das suas informações pessoais se (i) tiver dúvidas quanto à exatidão das suas informações pessoais; (ii) considerar que as suas informações pessoais foram tratadas de forma ilícita; (iii) necessitar que conservemos as informações pessoais unicamente para efeitos de um processo judicial; ou (iv) estivermos a analisar a sua oposição relativamente ao tratamento com base em interesses legítimos.",
   "objecting-to-processing-text": "Oposição ao tratamento: Tem o direito de se opor ao tratamento das suas informações pessoais que se baseie nos nossos interesses legítimos ou no interesse público. Caso o faça, seremos obrigados a apresentar motivos legítimos imperiosos para o tratamento, que prevaleçam sobre os seus interesses, direitos e liberdades, para podermos prosseguir com o tratamento das suas informações pessoais.",
   "data-portability-text": "Portabilidade dos dados: Poderá ter o direito de solicitar uma cópia das informações pessoais que detemos sobre si. Sempre que possível, forneceremos essas informações em formato CSV ou noutro formato de máquina facilmente legível. Poderá também ter o direito de solicitar que transfiramos essas informações pessoais para um terceiro.",
   "deletion-rights-text": "Eliminação: Poderá ter o direito de solicitar, a qualquer momento, que eliminemos as informações pessoais que detemos sobre si, e tomaremos as medidas razoáveis para eliminar as suas informações pessoais dos nossos registos atuais. Se nos solicitar que eliminemos as suas informações pessoais, informá-lo-emos sobre a forma como essa eliminação afeta a sua utilização dos nossos sítios web ou produtos e serviços. Poderão existir exceções a este direito por razões legais específicas que, caso sejam aplicáveis, lhe indicaremos em resposta ao seu pedido. Se encerrar ou eliminar a sua conta, eliminaremos as suas informações pessoais no prazo de 45 dias após a eliminação da sua conta. Tenha em atenção que os motores de pesquisa e terceiros semelhantes poderão continuar a conservar cópias das suas informações pessoais que tenham sido tornadas públicas pelo menos uma vez, como determinadas informações de perfil e comentários públicos, mesmo depois de ter eliminado essas informações dos nossos serviços ou desativado a sua conta.",
   "us-states-privacy-title": "Divulgações Adicionais para Cumprimento da Legislação de Privacidade dos Estados dos EUA.",
   "us-states-privacy-description-text": "A secção seguinte inclui disposições que cumprem as leis de privacidade destes estados (California, Colorado, Delaware, Florida, Virginia e Utah) e aplica-se exclusivamente aos residentes desses estados. As referências específicas a um determinado estado (num título ou no texto) constituem apenas uma referência à legislação desse estado e aplicam-se apenas aos residentes desse estado. A linguagem não específica a um estado aplica-se a todos os estados acima indicados.",
   "do-not-track-title": "Não Rastrear",
   "do-not-track-description-text": "Alguns navegadores possuem uma funcionalidade de \"Não Rastrear\" que lhe permite informar os sítios Web de que não pretende que as suas atividades em linha sejam rastreadas. Neste momento, não respondemos aos sinais de \"Não Rastrear\" do navegador.",
   "do-not-track-standards-text": "Cumprimos as normas estabelecidas na presente política de privacidade, assegurando que recolhemos e tratamos os dados pessoais de forma lícita, leal, transparente e com motivos legítimos e legais para o fazer.",
   "cookies-and-pixels-title": "Cookies e Pixels",
   "cookies-and-pixels-description-text": "Pode, a qualquer momento, recusar os cookies dos nossos sítios, caso o seu navegador o permita. A maioria dos navegadores permite-lhe ativar definições no seu navegador para recusar a configuração de todos ou de alguns cookies. Consequentemente, a sua capacidade de limitar os cookies depende apenas das funcionalidades do seu navegador. Para mais informações, consulte a secção de Cookies da presente política de privacidade.",
   "california-privacy-laws-title": "Leis de Privacidade da California - CPPA",
   "california-privacy-financial-incentive-text": "Nos termos da Secção 1798.83 do Código Civil da Califórnia, se residir na Califórnia e a sua relação comercial connosco se destinar principalmente a fins pessoais, familiares ou domésticos, poderá solicitar-nos informações sobre os dados que divulgamos a outras organizações para efeitos de marketing por parte destas. Em conformidade com o seu direito à não discriminação, poderemos oferecer-lhe determinados incentivos financeiros permitidos pela California Consumer Privacy Act e pela California Privacy Rights Act (em conjunto, CCPA), que podem resultar em preços, tarifas ou níveis de qualidade diferentes para os bens ou serviços que prestamos. Qualquer incentivo financeiro permitido pela CCPA que ofereçamos estará razoavelmente relacionado com o valor das suas informações pessoais, e disponibilizaremos termos escritos que descrevam claramente a natureza dessa oferta. A participação num programa de incentivos financeiros requer o seu consentimento prévio e expresso, que poderá revogar a qualquer momento.",
   "california-privacy-request-info-text": "Nos termos da Secção 1798.83 do Código Civil da Califórnia, se residir na Califórnia e a sua relação comercial connosco se destinar principalmente a fins pessoais, familiares ou domésticos, poderá solicitar-nos informações sobre os dados que divulgamos a outras organizações para efeitos de marketing por parte destas. Para efetuar esse pedido, contacte-nos através dos dados indicados nesta política de privacidade, indicando «Pedido de informações de privacidade da Califórnia» na linha de assunto. Este tipo de pedido pode ser feito uma vez por ano civil. Enviar-lhe-emos por correio eletrónico uma lista das categorias de informações pessoais que divulgámos a outras organizações para efeitos de marketing por parte destas no último ano civil, juntamente com os respetivos nomes e endereços. Nem todas as informações pessoais partilhadas desta forma estão abrangidas pela Secção 1798.83 do Código Civil da Califórnia.",
   "california-notice-of-collection-title": "Aviso de Recolha da Califórnia",
   "california-notice-of-collection-intro-text": "Nos últimos 12 meses, recolhemos as seguintes categorias de informações pessoais enumeradas na CCPA:",
   "ccpa-identifiers-text": "Identificadores, tais como nome, endereço de correio eletrónico, número de telefone, nome de utilizador da conta, endereço IP e um identificador ou número atribuído à sua conta.",
   "ccpa-customer-records-text": "Registos de clientes, tais como morada de faturação e de envio, e dados de cartão de crédito ou débito.",
   "ccpa-demographics-text": "Dados demográficos, tais como a sua idade ou género. Esta categoria inclui dados que podem ser qualificados como classificações protegidas ao abrigo de outras leis da Califórnia ou leis federais.",
   "ccpa-commercial-info-text": "Informações comerciais, tais como o histórico de produtos ou serviços e compras.",
   "ccpa-internet-activity-text": "Atividade na Internet, tal como as suas interações com o nosso serviço.",
   "ccpa-audio-visual-text": "Dados áudio ou visuais, tais como fotografias ou vídeos que partilhe connosco ou publique no serviço.",
   "ccpa-geolocation-text": "Dados de geolocalização.",
   "ccpa-employment-education-text": "Dados relativos a emprego e educação, tais como os dados que fornece ao candidatar-se a um emprego connosco.",
   "ccpa-inferences-text": "Inferências, tais como informações sobre os seus interesses, preferências e favoritos.",
   "california-notice-of-collection-outro-text": "Para mais informações sobre as informações que recolhemos, incluindo as fontes a partir das quais recebemos informações, consulte a secção \"Informações que Recolhemos\". Recolhemos e utilizamos estas categorias de informações pessoais para as finalidades comerciais descritas na secção \"Recolha e Utilização de Informações\", incluindo para fornecer e gerir o nosso Serviço.",
   "right-to-know-delete-title": "Direito de Conhecer e Eliminar",
   "right-to-know-delete-intro-text": "Tem o direito de eliminar as informações pessoais que recolhemos e de conhecer determinadas informações sobre as nossas práticas de dados nos 12 meses anteriores. Em particular, tem o direito de nos solicitar o seguinte:",
   "know-delete-categories-collected-text": "As categorias de informações pessoais que recolhemos sobre si;",
   "know-delete-categories-sources-text": "As categorias de fontes a partir das quais as informações pessoais foram recolhidas;",
   "know-delete-categories-disclosed-text": "As categorias de informações pessoais sobre si que divulgámos para uma finalidade comercial ou que vendemos;",
   "know-delete-third-parties-text": "As categorias de terceiros a quem as informações pessoais foram divulgadas para uma finalidade comercial ou vendidas;",
   "know-delete-business-purpose-text": "A finalidade comercial ou empresarial para a recolha ou venda das informações pessoais; e",
   "know-delete-specific-pieces-text": "Os elementos específicos de informações pessoais que recolhemos sobre si.",
   "right-to-know-delete-outro-text": "Para exercer qualquer um destes direitos, contacte-nos utilizando os dados de contacto fornecidos nesta política de privacidade.",
   "shine-the-light-title": "Shine the Light",
   "shine-the-light-description-text": "Para além dos direitos acima referidos, tem o direito de nos solicitar informações relativamente à forma como partilhamos determinadas informações pessoais, conforme definido pela legislação aplicável, com terceiros e afiliadas para os seus próprios fins de marketing direto.",
   "shine-the-light-request-text": "Para receber esta informação, envie-nos um pedido através dos dados de contacto indicados nesta política de privacidade. Os pedidos devem incluir a menção \"Pedido de Direitos de Privacidade\" na primeira linha da descrição e incluir o seu nome, morada, cidade, estado e código postal.",
   "contact-us-title": "Contacte-nos",
   "privacy-contact-us-description-text": "Para quaisquer questões ou preocupações relativas à sua privacidade, pode contactar-nos através dos seguintes dados:",
   "customer-service-label": "Apoio ao Cliente",

   // My Performance (Staff)
   "loading-ellipsis-text": "A carregar...",
   "failed-to-load-modules-error": "Falha ao carregar os módulos",
   "failed-to-load-details-error": "Falha ao carregar os detalhes",
   "my-assessments-title": "As minhas avaliações",
   "my-assessments-description-text":
      "Comece por selecionar uma avaliação para ver os seus módulos e informações de desempenho.",
   "no-assessments-yet-title": "Parece que ainda não há avaliações!",
   "no-assessments-yet-description-text":
      "Quando as avaliações tiverem resultados, aparecerão aqui para explorar.",
   "modules-in-assessment-label": "Módulos nesta avaliação:",
   "choose-module-to-see-results-text": "Escolha um módulo para ver os resultados",
   "status-closed-label": "Encerrada",
   "select-module-alt-text": "Selecionar módulo",
   "select-module-results-text": "Selecione um módulo da lista para ver os seus resultados",
   "target-label": "Meta",
   "action-plan-label": "Plano de ação",
   "assessment-preview-title": "Pré-visualização da avaliação",
   "no-data-for-assessment-text": "Não existem dados disponíveis para esta avaliação de momento",
   "my-upcoming-tasks-title": "As minhas tarefas futuras",
   "my-improvement-over-time-title": "A minha evolução ao longo do tempo",
   "no-data-for-survey-text": "Não existem dados disponíveis para este inquérito de momento",
   "your-score-label": "A sua pontuação",
   "target-score-label": "Pontuação-alvo",
   "previous-label": "Anterior",
   "next-label": "Seguinte",

   // Task Management (Staff)
   "task-management-title": "Gestão de tarefas",
   "tasks-tab-label": "Tarefas",
   "assigned-modules-title": "Módulos atribuídos",
   "collapse-all-button": "Recolher tudo",
   "expand-all-button": "Expandir tudo",
   "assigned-tasks-title": "Tarefas Atribuídas",
   "board-tab-label": "Quadro",
   "timeline-tab-label": "Cronologia",
   "no-available-modules-text": "Não existem módulos disponíveis para esta avaliação",
   "no-available-tasks-text": "Não existem tarefas disponíveis para esta avaliação",
   "go-alt-text": "Ir",
   "view-alt-text": "Ver",
   "notes-alt-text": "Notas",
   "change-status-to-label": "Alterar o estado para:",
   "priority-low-label": "Baixa",
   "priority-medium-label": "Média",
   "priority-high-label": "Alta",
   "priority-urgent-label": "Urgente",
   "show-less-link": "Mostrar menos",
   "monthly-toggle-label": "Mensal",
   "quarterly-toggle-label": "Trimestral",
   "week-prefix-text": "Semana",
   "to-do-status": "Por fazer",
   "tasks-column-header": "Tarefas",
   "linked-questions-prefix-text": "Perguntas relacionadas:",
   "assigned-status": "Atribuído",
   "action-plan-dashboard-title": "Painel do plano de ação",
   "action-plan-for-label": "Plano de ação para",

   "role-vendor-label": "Fornecedor",
   "switch-role-label": "Mudar de função",
   "current-role-label": "Função atual",
   "switch-role-error-description": "Não foi possível mudar a sua função, tente novamente.",
   "approver-role-added-to-existing-user-description":
      "Este utilizador já tinha uma conta, por isso não foi enviado nenhum e-mail de convite. Inicia sessão com a palavra-passe existente e muda para a função de Aprovador.",

   // Dual role (Expert + Approver on the same account)
   "expert-role-column": "Especialista",
   "expert-role-enabled-success-title": "Função de Especialista adicionada",
   "expert-role-enabled-success-description": "Este aprovador agora também pode trabalhar como especialista.",
   "expert-role-disabled-success-title": "Função de Especialista removida",
   "expert-role-disabled-success-description": "Este aprovador já não tem a função de especialista.",
   "expert-role-toggle-error-description": "Não foi possível atualizar a função de especialista, tente novamente.",
   "expert-role-not-found-description": "Este aprovador já não existe. A lista foi atualizada.",
   "approver-role-column": "Aprovador",
   "approver-role-enabled-success-title": "Função de Aprovador adicionada",
   "approver-role-enabled-success-description": "Este especialista agora também pode trabalhar como aprovador.",
   "approver-role-disabled-success-title": "Função de Aprovador removida",
   "approver-role-disabled-success-description": "Este especialista já não tem a função de aprovador.",
   "approver-role-toggle-error-description": "Não foi possível atualizar a função de aprovador, tente novamente.",
   "approver-role-not-found-description": "Este especialista já não existe. A lista foi atualizada.",
   "expert-exists-redirect-title": "Já é Especialista",
   "expert-exists-redirect-description":
      "Este e-mail já pertence a um Especialista. Vamos levá-lo à lista de Especialistas, onde pode atribuir-lhe a função de Aprovador.",

   "linked-assessment-edit-notice":
      "Esta avaliação está ligada a outra, pelo que só podem ser adicionadas novas rondas. Cada ronda adicionada aqui é também adicionada à avaliação ligada.",
   "start-date-in-past-validation": "A data de início não pode estar no passado.",
   "end-date-must-be-future-validation": "A data de fim tem de estar no futuro.",
   "round-overlaps-another-round-validation": "Esta ronda sobrepõe-se a outra ronda.",
   "view-all-notifications-button": "Ver todas as notificações",
   "notifications-page-title": "Notificações",
   "notifications-empty-title": "Ainda não há notificações",
   "notifications-unread-empty-title": "Nenhuma notificação não lida",
   "notifications-empty-text": "Você está em dia. Novas notificações aparecerão aqui.",
   "guided-assessment-completed-prefix-text": "A sua avaliação guiada",
   "guided-assessment-completed-suffix-text": "está concluída.",
   "notification-title-org-signup": "Novo registo de organização",
   "notification-title-expert-signup": "Novo registo de especialista",
   "notification-title-workspace-join-request": "Pedido de organização para aderir ao espaço de trabalho",
   "notification-title-workspace-approved": "Pedido de espaço de trabalho aprovado",
   "notification-title-workspace-rejected": "Pedido de espaço de trabalho rejeitado",
   "notification-title-guided-request": "Pedido de avaliação guiada",
   "notification-title-guided-approved": "Pedido de avaliação guiada aprovado",
   "notification-title-guided-rejected": "Pedido de avaliação guiada rejeitado",
   "notification-title-guided-completed": "Avaliação guiada concluída",
   "notification-title-self-assigned": "Nova autoavaliação atribuída",
   "notification-title-self-unassigned": "Autoavaliação removida",
   "notification-title-expert-assigned": "Atribuído a avaliação guiada",
   "notification-title-ticket-created": "Novo ticket criado",
   "notification-title-ticket-updated": "Ticket atualizado",
   "notification-title-submission-review": "Submissão pronta para revisão",
   "notification-title-submission-approved-by-approver": "Submissão aprovada pelo aprovador",
   "notification-title-submission-rejected-by-approver": "Submissão rejeitada pelo aprovador",
   "notification-title-module-assigned": "Novo módulo atribuído",
   "notification-title-module-unassigned": "Módulo removido",
   "notification-title-submission-approved": "Submissão aprovada",
   "notification-title-submission-rejected": "Submissão rejeitada",
   "notification-title-submission-approval": "Submissão pronta para aprovação",
   "mark-as-read-label": "Marcar como lida",
   "notification-actions-label": "Ações da notificação"
};
